import React from 'react';
import './TermsAndCondition.css';
import OhMyFoodLogo from '../../../assets/svg/OhMyFoodLogo';
import OhMyFoodText from '../../../assets/svg/OhMyFoodText';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO } from '../../../Utils/Constant';

const TermsAndCondition = () => {
    return (
        <div>
            <Helmet>
                <title>{SEO.TERMS_AND_CONDITIONS_PAGE.TITLE}</title>
                <meta name="description" content={SEO.TERMS_AND_CONDITIONS_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.TERMS_AND_CONDITIONS_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.TERMS_AND_CONDITIONS_PAGE.CANONICAL} />

                {/* Open Graph */}
                <meta property="og:title" content={SEO.TERMS_AND_CONDITIONS_PAGE.TITLE} />
                <meta property="og:description" content={SEO.TERMS_AND_CONDITIONS_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.TERMS_AND_CONDITIONS_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.TERMS_AND_CONDITIONS_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.TERMS_AND_CONDITIONS_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
            
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.TERMS_AND_CONDITIONS_PAGE.TITLE} />
                <meta name="twitter:description" content={SEO.TERMS_AND_CONDITIONS_PAGE.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />

                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        'name': `${SEO.TERMS_AND_CONDITIONS_PAGE.TITLE}`,
                        'description': 'Review the terms and conditions for using OMF, your go-to food discovery and delivery platform.',
                        'url': `${CONSTANT.OMYFOOD_WEB_LINK}/terms-and-conditions`
                    })
                    }
                </script>
            </Helmet>
            <div className='terms-condition-header'>
                <OhMyFoodLogo />
                <OhMyFoodText className='terms-condition-logo' />
            </div>
            <div className='terms-container'>
                <h1 className='terms-title'>Consumer Terms and Conditions</h1>
                <p className='terms-effective'>Effective: January 25, 2025</p>

                {/* Introduction */}
                <section className='terms-section'>
                    <p className='terms-text'>
                        <strong>
              PLEASE READ THESE CONSUMER TERMS AND CONDITIONS CAREFULLY.
                        </strong>
            THESE CONSUMER TERMS AND CONDITIONS (“AGREEMENT,” “TERMS AND
            CONDITIONS,” or “TERMS”) CONSTITUTE A LEGAL AGREEMENT BETWEEN YOU
            AND OHMYFOOD, AS DEFINED BELOW.
                    </p>
                    <p className='terms-text'>
            SECTION 14 OF THIS AGREEMENT (WHICH DOES NOT APPLY TO CANADA
            CONSUMERS RESIDING IN THE PROVINCE OF QUÉBEC) CONTAINS PROVISIONS
            THAT GOVERN HOW CLAIMS THAT YOU AND WE HAVE AGAINST EACH OTHER ARE
            RESOLVED, INCLUDING, WITHOUT LIMITATION, ANY CLAIMS THAT AROSE OR
            WERE ASSERTED BEFORE THE EFFECTIVE DATE OF THIS AGREEMENT. IN
            PARTICULAR, SECTION 14 SETS FORTH OUR ARBITRATION AGREEMENT WHICH
            WILL REQUIRE DISPUTES BETWEEN US TO BE SUBMITTED TO ARBITRATION,
            WITH LIMITED EXCEPTIONS (FOR EXAMPLE, NEW ZEALAND CONSUMERS ARE
            GOVERNED BY SECTION 14(c)(iv) OF THIS AGREEMENT, AND UNITED STATES
            CONSUMERS DO NOT NEED TO ARBITRATE INDIVIDUAL CLAIMS OF SEXUAL
            HARASSMENT OR SEXUAL ASSAULT IN CONNECTION WITH THEIR USE OF THE
            SERVICES). UNLESS YOU OPT OUT OF THE ARBITRATION AGREEMENT AND TO
            THE EXTENT PERMITTED BY APPLICABLE LAW: (1) YOU WILL ONLY BE
            PERMITTED TO PURSUE CLAIMS AND SEEK RELIEF AGAINST US ON AN
            INDIVIDUAL BASIS, NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR
            REPRESENTATIVE ACTION OR PROCEEDING (EXCEPT FOR AUSTRALIA
            CONSUMERS); AND (2) YOU ARE WAIVING YOUR RIGHT TO SEEK RELIEF IN A
            COURT OF LAW AND TO HAVE A JURY TRIAL ON YOUR CLAIMS. THE
            ARBITRATION AGREEMENT COULD AFFECT YOUR RIGHT TO PARTICIPATE IN
            PENDING OR PROPOSED CLASS ACTION LITIGATION.
                    </p>
                    <p className='terms-text'>IN ADDITION:</p>
                    <ul className='terms-list'>
                        <li>
              SECTION 4 OF THIS AGREEMENT REQUIRES YOU TO CONSENT TO OUR PRIVACY
              POLICY.
                        </li>
                        <li>
              SECTION 8 OF THIS AGREEMENT CONTAINS PROVISIONS RELATING TO OUR
              USE OF CERTAIN USER CONTENT.
                        </li>
                        <li>
              SECTION 13 OF THIS AGREEMENT CONTAINS PROVISIONS RELATING TO
              OHMYFOODPASS.
                        </li>
                        <li>
              SECTION 20 OF THIS AGREEMENT CONTAINS PROVISIONS WHICH LIMIT OUR
              LIABILITY TO YOU.
                        </li>
                    </ul>
                </section>

                {/* Section 1 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>1. Application of this Agreement</h2>
                    <p className='terms-text'>
            This Agreement governs your access to and use of the Technology and
            Services (each as defined below) and is between you and OHMYFOOD.
            “OHMYFOOD,” “we,” “us,” and “our” mean OHMYFOOD, Inc., a Delaware
            corporation, and its subsidiaries and affiliated companies,
            including, without limitation, the entities listed in the remainder
            of this paragraph. With respect to United States Orders (as defined
            below), these Terms and Conditions constitute a legal agreement
            between you and OHMYFOOD, Inc. and/or its subsidiaries and
            affiliated companies, including OHMYFOOD G&C, LLC (depending on the
            Merchant, as defined below). With respect to Australia Orders (as
            defined below), these Terms and Conditions constitute a legal
            agreement between you and OHMYFOOD Technologies Australia Pty Ltd
            ACN 634 446 030 and/or its subsidiaries and affiliated companies.
            With respect to Canada Orders (as defined below), these Terms and
            Conditions constitute a legal agreement between you and OHMYFOOD
            Technologies Canada, Inc. and/or its subsidiaries and affiliated
            companies. With respect to New Zealand Orders (as defined below),
            these Terms and Conditions constitute a legal agreement between you
            and OHMYFOOD Technologies New Zealand NZCN 8252064, a New Zealand
            company, and/or its subsidiaries and affiliated companies. With
            respect to Puerto Rico Orders (as defined below), these Terms and
            Conditions constitute a legal agreement between you and OHMYFOOD
            Technologies Puerto Rico, LLC and/or its subsidiaries and affiliated
            companies.
                    </p>
                    <p className='terms-text'>
            Certain provisions of this Agreement apply based on the country of
            your primary residence or the country in which you have selected a
            delivery or pickup address, and such provisions are designated as
            such using one or more of the following definitions:
                    </p>
                    <ul className='terms-list'>
                        <li>
              “Australia Consumer” means your primary residence is in Australia.
                        </li>
                        <li>
              “Australia Order” means you have selected a delivery or pickup
              address in Australia.
                        </li>
                        <li>
              “Canada Consumer” means your primary residence is in Canada.
                        </li>
                        <li>
              “Canada Order” means you have selected a delivery or pickup
              address in Canada.
                        </li>
                        <li>
              “New Zealand Consumer” means your primary residence is in New
              Zealand.
                        </li>
                        <li>
              “New Zealand Order” means you have selected a delivery or pickup
              address in New Zealand.
                        </li>
                        <li>
              “Puerto Rico Order” means you have selected a delivery or pickup
              address in Puerto Rico, a United States territory.
                        </li>
                        <li>
              “United States Consumer” means your primary residence is in the
              United States, including Puerto Rico, a United States territory.
                        </li>
                        <li>
              “United States Order” means you have selected a delivery or pickup
              address in the United States, including Puerto Rico, a United
              States territory (except as otherwise noted).
                        </li>
                    </ul>
                </section>

                {/* Section 2 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>2. Acceptance of this Agreement</h2>
                    <p className='terms-text'>
            OHMYFOOD operates an online marketplace and connection platform to
            (a) broker the exchange of goods and services among you and other
            consumers, restaurants and other businesses (“Merchants”), and
            independent third-party contractors who provide delivery and/or
            other services (“Contractors”); and (b) provide you with access to
            information on the Services. OHMYFOOD’s Technology permits consumers
            to place orders for food and/or other goods from Merchants, either
            for delivery or pickup, and/or request services from Merchants. If a
            delivery order is made, OHMYFOOD uses the Technology to notify
            Contractors (or, for certain orders, Merchants) that a delivery
            opportunity is available and to facilitate completion of the
            delivery to the consumer. If a pickup order is made, OHMYFOOD uses
            the Technology to communicate with the consumer regarding the
            availability of the order for pickup. OHMYFOOD is not a merchant,
            retailer, restaurant, grocer, delivery service, or food preparation
            business (except as otherwise specified in Section 6 below).
                    </p>
                    <p className='terms-text'>
            If you access any of our websites located at www.OMyFood.io ,
            install or use the OHMYFOOD Technology, access or use any
            information, function, feature, or service made available or enabled
            by OHMYFOOD (collectively, the “Services,” which includes the
            Technology), click or tap a button or take similar action to signify
            your affirmative acceptance of this Agreement, or complete the
            OHMYFOOD account registration process, you, your heirs, assigns, and
            successors (collectively, “you” or “your”) hereby represent and
            warrant that: (a) you have read, understand, and agree to be bound
            by this Agreement and any future amendments and additions to this
            Agreement as published from time to time at www.OMyFood.io/terms/ or
            through the Technology; (b) you are of legal age in the jurisdiction
            in which you reside to form a binding contract with OHMYFOOD; and
            (c) you have the authority to enter into the Agreement personally
            and, if applicable, on behalf of any organization for whom you have
            created an account or been named as the User during the OHMYFOOD
            account registration process and to bind such organization to the
            Agreement.
                    </p>
                    <p className='terms-text'>
            The specific Services or information available to you may vary based
            on the delivery or pickup address that you have selected. A certain
            function, feature, or Service (y) available to one User may not be
            available to all Users or at all times, and (z) may only be
            available in the latest version of the OHMYFOOD or Caviar mobile
            application. “User” means any individual or other person who
            accesses or uses the Services with or without an account (whether
            directly or through tools, services, or other means), including,
            without limitation, any organization that registers an account or
            otherwise accesses or uses the Services through its respective
            employees, agents, or representatives. Except as otherwise provided
            in this Agreement, if you do not agree to be bound by the Agreement,
            you may not access or use the Services.
                    </p>
                </section>

                {/* Section 3 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>3. Modifications</h2>
                    <p className='terms-text'>
            Subject to Section 14(k) of this Agreement, OHMYFOOD reserves the
            right to modify the terms and conditions of this Agreement or its
            policies relating to the Technology or Services at any time,
            effective upon posting an updated version of this Agreement at
            www.OMyFood.io/terms/ or through the Technology. If we make any
            material changes to this Agreement, we will notify you by email at
            the email address that you have provided to us or by another means.
            You should regularly review this Agreement, as your continued use of
            the Services after any such changes constitutes your agreement to
            such changes. If you do not agree to this Agreement or any
            modifications to this Agreement, you should immediately cease using
            the Technology and Services.
                    </p>
                </section>

                {/* Section 4 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>4. Additional Terms and Policies</h2>
                    <p className='terms-text'>
            By using or accessing the Services, you agree to be bound by this
            Agreement and acknowledge and agree to the collection, use, and
            disclosure of your personal information in accordance with
            OHMYFOOD’s{' '}
                        <a
                            href='/privacy-policy' //our privacy policy link
                            className='inline-link'
                        >
              Privacy Policy
                        </a>
            , which is incorporated in this Agreement by reference. You also
            agree to abide by any additional OHMYFOOD terms or policies for
            Users that are published on our website or mobile application,
            whether or not such terms or policies are directly referenced or
            linked elsewhere in this Agreement. Certain features of our Services
            may be subject to additional terms and conditions, which, to the
            extent permitted by applicable law, are incorporated herein by
            reference.
                    </p>
                    <p className='terms-text'>
            If you use the OHMYFOOD Developer Portal, you also accept and agree
            to be bound by the Developer Portal Technology License & Terms of
            Use (“Developer Portal Terms”) when using the Developer Portal. If
            there’s any conflict between the Developer Portal Terms and this
            Agreement, the Developer Portal Terms shall control to the extent
            related to the Developer Portal.
                    </p>
                </section>

                {/* Section 5 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>5. Rules and Prohibitions</h2>
                    <p className='terms-text'>
            Without limiting other rules and prohibitions in this Agreement, by
            using or accessing the Services (whether or not you have created an
            account or are logged into an account), you agree that:
                    </p>
                    <ul className='list-inside'>
                        <li>
              (a) You will only use or access the Services for lawful purposes
              and you will not use or attempt to use the Services under false
              pretenses or for sending or storing any unlawful material or for
              deceptive or fraudulent purposes.
                        </li>
                        <li>
              (b) You will only use or access the Services in accordance with
              all applicable laws, including copyrights, trade secrets, other
              intellectual property rights, or other rights of any third party,
              including privacy, personality, or publicity rights.
                        </li>
                        <li>
              (c) You will only use or access the Services using means
              explicitly authorized by OHMYFOOD. If applicable, it is your
              responsibility to ensure you download the correct Technology for
              your device. We are not liable if you do not have a compatible
              device or if you have downloaded the wrong version of the
              Technology for your device. We reserve the right to terminate your
              use of the Technology and/or Services if you are using the
              Technology or Services with an incompatible or unauthorized
              device.
                        </li>
                        <li>
              (d) You will not use or attempt to use another User’s account,
              impersonate any person or entity, or forge or manipulate headers
              or identifiers to disguise the origin of any content transmitted
              through the Services.
                        </li>
                        <li>
              (e) You will not use or attempt to use the Services to cause
              nuisance, annoyance, or inconvenience.
                        </li>
                        <li>
              (f) You will not use or attempt to use the Services, or any
              content accessible through the Services (including content
              accessible without being logged into your account), for any
              commercial purpose, including but not limited to contacting,
              advertising to, soliciting, or selling to any Merchant, User, or
              Contractor, unless OHMYFOOD has given you prior permission to do
              so in writing.
                        </li>
                        <li>
              (g) You will not use or attempt to use the Services or content
              accessible through the Services without OHMYFOOD&apos;s prior
              written consent in connection with the development of any software
              program, including, but not limited to, training a machine
              learning or artificial intelligence (AI) system or providing
              archived or cached data sets containing content accessible through
              the Services to another person or entity.
                        </li>
                        <li>
              (h) You will not copy or distribute, or attempt to copy or
              distribute, the Technology or any content displayed through the
              Services, including any reviews or Merchants’ menu content or
              catalogs, for republication in any format or media.
                        </li>
                        <li>
              (i) You will not directly or indirectly create or compile, or
              attempt to create or compile, any content or collection,
              compilation, or other directory from any content displayed through
              the Services except for your personal, noncommercial use.
                        </li>
                        <li>
              (j) The information you provide to us when you register an account
              or otherwise communicate with us is accurate, you will promptly
              notify us of any changes to such information, and you will provide
              us with whatever proof of identity we may reasonably request.
                        </li>
                        <li>
              (k) You will keep secure and confidential your account password
              and any other login or identification credentials you use to
              access the Services.
                        </li>
                        <li>
              (l) You will use the Technology and Services only for your own use
              and will not directly or indirectly resell, license, or transfer
              the Technology, Services, or content displayed through the
              Services (including content accessible without being logged into
              your account) to a third party.
                        </li>
                        <li>
              (m) You will not use or attempt to use the Services in any way
              that could damage, disable, overburden, or impair any OHMYFOOD
              server or the networks connected to any OHMYFOOD server.
                        </li>
                        <li>
              (n) You will not attempt to gain unauthorized access to any part
              of the Technology or the Services and/or to any account, resource,
              computer system, and/or network connected to any OHMYFOOD server.
                        </li>
                        <li>
              (o) You will not probe, scan, or test the vulnerability of any
              system or network or breach or circumvent any security or
              authentication measures OHMYFOOD may use to prevent or restrict
              access to the Services or use of the Services or the content
              therein, and you will not attempt any of the foregoing.
                        </li>
                        <li>
              (p) You will not use, access, or collect content, data,
              information, or materials published or available on the
              Services—including, but not limited to, text, photographs, images,
              illustrations, designs, audio clips, video clips, “look and feel,”
              metadata, data, or compilations—using automated means unless
              OHMYFOOD has given you prior permission to do so in writing.
                        </li>
                        <li>
              (q) You will not deep-link to our websites or access our websites
              manually or with any robot, spider, script, web crawler,
              extraction software, automated process, service, tool, and/or
              device to scrape, copy, index, frame, or monitor any portion of
              our Services or websites or any content on or available through
              our Services or websites, and you will not attempt any of the
              foregoing.
                        </li>
                        <li>
              (r) You will not scrape or otherwise conduct any systematic
              retrieval of data or other content from the Services (including
              content accessible without being logged into your account), and
              you will not attempt any of the foregoing.
                        </li>
                        <li>
              (s) You will not engage in conduct that harms, attempts to harm,
              or threatens the safety of other Users, Merchants, Contractors,
              OHMYFOOD, OHMYFOOD employees, or our community in any way
              whatsoever, and you will take reasonable steps to prevent the
              foregoing.
                        </li>
                        <li>
              (t) You will not engage in threatening, harassing, racist, or
              sexist behavior or any other behavior that OHMYFOOD deems
              inappropriate when using the Services.
                        </li>
                        <li>
              (u) You will report any errors, bugs, unauthorized access
              methodologies, or any breach of our intellectual property rights
              that you uncover in your use of the Services.
                        </li>
                        <li>
              (v) You will not abuse or attempt to abuse our promotional or
              credit code system, including by redeeming multiple coupons at
              once or by opening multiple accounts to benefit from offers
              available only to first-time Users.
                        </li>
                        <li>
              (w) Your participation in using and access to the Services is for
              your sole, personal, or internal business use.
                        </li>
                        <li>
              (x) You will not falsely or fraudulently claim that your order or
              items from your order were missing, incorrect, of poor quality,
              defective, or never delivered and you will return any order
              mistakenly delivered to you if requested by OHMYFOOD, a Merchant,
              or a Contractor.
                        </li>
                        <li>
              (y) You will not, in connection with your use of the Services
              and/or the OHMYFOOD platform: (i) ask a Contractor to purchase or
              deliver any goods or perform any services not ordered through the
              OHMYFOOD platform; or (ii) give or offer to give any goods to a
              Contractor related to your OHMYFOOD order.
                        </li>
                    </ul>
                    <p className='terms-text'>
            In the event that we believe or determine that you have breached any
            of the aforementioned or any other provision of these Terms, we
            reserve the right to suspend and/or permanently deactivate your
            account or take other appropriate action at our sole discretion.
            Where required by law, which may include in the Province of Québec,
            we will provide you with written notice of the suspension or
            deactivation of your account, including the reasons which led us to
            take such action. Engaging in any prohibited use of the Services may
            result in criminal, civil, and/or administrative penalties, fines,
            or sanctions against the User and those assisting the User.
                    </p>
                </section>

                {/* Section 6 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>
            6. Contractors and Merchants Are Independent
                    </h2>
                    <p className='terms-text'>
            (a) You understand and agree that OHMYFOOD provides the Services to
            connect you with independent Merchants that provide the products and
            services offered through the Services, and independent third-party
            Contractors who provide delivery and other services. You acknowledge
            and agree that OHMYFOOD is not a merchant, retailer, restaurant,
            grocer, pharmacy, chemist, delivery service, or food preparation
            business, and has no responsibility or liability for the acts or
            omissions of any Merchant or any Contractor. Merchants are the
            retailers of the products or services offered through the Services.
            OHMYFOOD is not in the delivery business, does not provide delivery
            services, and is not a common carrier. OHMYFOOD provides the
            Services to facilitate the transmission of orders by Users to
            Merchants, including orders for pickup or delivery by Contractors
            and/or Merchants. Any delivery, pickup, or preparation times
            displayed through the Services are purely estimates and do not
            represent a promise, commitment, or guarantee by OHMYFOOD. OHMYFOOD
            will not assess or guarantee the suitability, legality, or ability
            of any Contractor or Merchant. You agree that OHMYFOOD is not
            responsible for Merchants’ food preparation or product offerings,
            food or product handling, or the safety of the food or other
            products, or whether the photographs, images, menu or product
            listings, catalog, item descriptions, or other menu, product, or
            catalog information (including nutrition, ingredient, and/or
            allergen information) displayed through the Services accurately
            reflect the goods and services sold by Merchants and/or delivered by
            the Contractor and/or Merchant, and does not verify Merchants’
            compliance with applicable laws or regulations. You also acknowledge
            and agree that menu, product, or catalog listings, descriptions, or
            other information (including photographs or images or nutrition,
            ingredient, and/or allergen information) displayed through the
            Services may not have been provided directly by the Merchant.
            OHMYFOOD has no responsibility or liability for acts or omissions by
            any Merchant or Contractor. You agree that the goods that you
            purchase will be prepared by the Merchant you have selected, that
            title to the goods passes from the Merchant to you at the Merchant’s
            location, and that, for delivery orders, the Contractor and/or
            Merchant will be directed by your instructions to transport the
            products to your designated delivery location. You agree that
            neither the Contractor nor OHMYFOOD holds title to or acquires any
            ownership interest in any goods that you order through the Services.
            You must not do anything which seeks to create an encumbrance, lien,
            charge, or other interest in or over the goods that you order until
            title has passed to you.
                    </p>
                    <h3 className='terms-subheading'>
            (b) Notwithstanding Section 6(a):{' '}
                    </h3>
                    <ul className='terms-sublist'>
                        <li>
              (i)<strong>United States Orders.</strong> For United States Orders
              placed through the Services with OHMYFOOD Essentials, LLC (dba
              OHMYFOOD or other brands), OHMYFOOD Essentials, LLC is the
              Merchant and is therefore the retailer of the goods sold. OHMYFOOD
              Essentials, LLC is a subsidiary of OHMYFOOD, Inc. and is a
              Merchant listed on the Services.
                        </li>
                        <li>
              (ii)<strong>Canada Orders.</strong> For Canada Orders placed
              through the Services with Rapid Retail Canada, Inc. (dba OHMYFOOD
              or other brands), Rapid Retail Canada, Inc. is the Merchant and is
              therefore the retailer of the goods sold. Rapid Retail Canada,
              Inc. is an affiliate of OHMYFOOD Technologies Canada, Inc. and is
              a Merchant listed on the Services.
                        </li>
                    </ul>
                </section>

                {/* Section 7 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>7. User Account</h2>
                    <p className='terms-text'>
            You may be required to register for an account to use parts of the
            Services. You must provide accurate, current, and complete
            information during the registration process and at all other times
            when you use the Services, and to update the information to keep it
            accurate, current, and complete. You are the sole authorized User of
            any account you create through the Services. You are solely and
            fully responsible for all activities that occur under your password
            or account or through your device. You agree that you shall monitor
            your account to prevent use by minors, and you will accept full
            responsibility for any unauthorized use of your password or your
            account. You may not authorize others to use your User account, and
            you may not assign or otherwise transfer your User account to any
            other person or entity. Should you suspect that any unauthorized
            party may be using your password or account, you will notify
            OHMYFOOD immediately. OHMYFOOD will not be liable, and you may be
            liable, for losses, damages, liability, expenses, and fees incurred
            by OHMYFOOD or a third party arising from someone else using your
            account; however, if you are a Canada Consumer who resides in the
            Province of Québec, the foregoing does not limit OHMYFOOD’s
            liability for the consequences of its own acts or the acts of its
            representatives. If you provide any information that is untrue,
            inaccurate, not current, or incomplete, or if OHMYFOOD has
            reasonable grounds to suspect that such information is untrue,
            inaccurate, not current, or incomplete, OHMYFOOD has the right to
            suspend or terminate your account and refuse any and all current or
            future use of the Services (or any portion thereof). We may enable
            or require you to use a single set of login credentials to use the
            OHMYFOOD and/or Caviar services. You agree not to create an account
            or use the Services if you have been previously removed from the
            OHMYFOOD platform by OHMYFOOD or if you have been previously banned
            from use of the Services.
                    </p>
                </section>

                {/* Section 8 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>8. User Content</h2>
                    <ul className='list-inside'>
                        <li>
              (a)<strong>User Content.</strong> OHMYFOOD may provide you with
              interactive opportunities through the Services, including, by way
              of example, the ability to post content on the OHMYFOOD platform
              or otherwise provide to OHMYFOOD Ratings and Reviews (each as
              defined below), Feedback (as defined below), or other text,
              photos, images, or audio and video content (collectively,
                            <strong>“User Content”</strong>). You represent and warrant that
              you are the owner of, or otherwise have the right to provide, all
              User Content that you submit, post, and/or otherwise transmit
              through the Services. You further represent and warrant that any
              User Content submitted, posted, and/or otherwise transmitted
              through the Services by you or someone on your behalf or through
              your User account does not (i) violate any third-party right,
              including any copyright, trademark, patent, trade secret, privacy
              right, right of publicity, or any other intellectual property or
              proprietary right; (ii) contain material that is false,
              intentionally misleading, deceptive, defamatory, offensive,
              abusive, or pornographic, including material that racially or
              religiously vilifies, incites violence or hatred, or is likely to
              insult or humiliate others based on race, religion, ethnicity,
              gender, age, sexual orientation, or any physical or mental
              disability; (iii) contain sexually explicit or violent content or
              photos, images, or videos of weapons, illegal drugs, or hate
              symbols; (iv) contain any material that is unlawful or relates to
              unlawful conduct (including phishing and spoofing); (v) create a
              privacy or security risk to any person, including by soliciting
              personal information from any person, or contain any confidential,
              sensitive, private, or personally identifiable information; (vi)
              solicit money from any person; (vii) contain financial, legal,
              medical, or other professional advice; (viii) harm, abuse, harass,
              stalk, threaten, or otherwise offend; (ix) reflect negatively on
              OHMYFOOD, including OHMYFOOD’s goodwill, name, and reputation; (x)
              tamper with, hinder the operation of, or make unauthorized
              modifications to our websites or Technology; (xi) otherwise result
              in civil or criminal liability for you, OHMYFOOD, or any third
              party; (xii) violate any law or regulation; or (xiii) violate this
              Agreement or any community or content guidelines that OHMYFOOD may
              publish from time to time (including but not limited to our
              Content Guidelines). You hereby grant OHMYFOOD (including
              OHMYFOOD’s service providers) a perpetual, irrevocable,
              transferable, fully paid, royalty-free, non-exclusive, worldwide,
              fully sublicensable right and license to use, copy, display,
              publish, modify, remove, publicly perform, translate, create
              derivative works from, distribute, and/or otherwise use the User
              Content in connection with OHMYFOOD’s business and in all forms
              now known or hereafter invented (collectively,{' '}
                            <strong>“Uses”</strong>), without notification to and/or approval
              by you. You further grant OHMYFOOD a license to use your username,
              first name and last initial, profile photo (if available), and/or
              other User profile information, including, without limitation,
              your ratings history, to attribute User Content to you in
              connection with such Uses, without notification to or approval by
              you. You acknowledge, however, that OHMYFOOD has no obligation to
              attribute any User Content to you in connection with any Use. You
              agree that this license includes the right for other Users to
              access and use your User Content in conjunction with participation
              in the Services and as permitted through the functionality of the
              Services. In the interest of clarity, the license granted to
              OHMYFOOD herein shall survive termination of the Services or your
              account. OHMYFOOD reserves the right in its sole discretion to
              remove or disable access to any User Content from the Services,
              suspend or terminate your account at any time, or pursue any other
              remedy or relief available under equity or law if you post any
              User Content that violates this Agreement or any community or
              content guidelines we may publish or that we consider to be
              objectionable for any reason. You agree that OHMYFOOD may monitor
              and/or delete your User Content (but does not assume the
              obligation to do so) or may decide to not publish, display, or
              otherwise make available your User Content for any reason at
              OHMYFOOD’s sole discretion. OHMYFOOD may also access, read,
              preserve, and disclose any information as OHMYFOOD reasonably
              believes is necessary to satisfy any applicable law, regulation,
              legal process, or governmental request; enforce this Agreement,
              including investigation of potential violations hereof; detect,
              prevent, or otherwise address fraud, security, or technical
              issues; respond to User, Contractor, or Merchant support requests;
              or protect the rights, property, or safety of OHMYFOOD, our Users,
              and the public. We may aggregate your publicly viewable User
              Content and certain other information about you onto a User
              profile viewable by anyone, which you can choose to make public
              (meaning your publicly viewable User Content will be displayed on
              your profile) or restricted (meaning only certain information
              about you and your User Content will be displayed on your profile,
              such as the number of Reviews and photos you’ve submitted but not
              their contents).
                        </li>
                        <li>
              (b)<strong>Feedback.</strong> You agree that any submission of any
              ideas, suggestions, and/or proposals to OHMYFOOD through its
              suggestion, feedback, wiki, forum, or similar pages (
                            <strong>“Feedback,”</strong> which is considered User Content) is
              at your own risk and that OHMYFOOD has no obligations (including,
              without limitation, obligations of confidentiality) with respect
              to such Feedback. You represent and warrant that you have all
              rights necessary to submit the Feedback and you hereby grant to
              OHMYFOOD (including OHMYFOOD’s service providers) a perpetual,
              irrevocable, transferable, fully paid, royalty-free,
              non-exclusive, worldwide, fully sublicensable right and license to
              use, copy, display, publish, modify, remove, publicly perform,
              translate, create derivative works from, distribute, and/or
              otherwise use such Feedback.
                        </li>
                        <li>
              (c)<strong>Ratings and Reviews.</strong> To the extent that you
              rate or post reviews of Merchants or other businesses, which may
              include but is not limited to text, photos, images, audio, or
              videos that you provide (<strong>“Ratings”</strong> and
                            <strong>“Reviews”</strong>), such Ratings and Reviews are
              considered User Content and are governed by this Agreement.
              Ratings and Reviews are not endorsed by OHMYFOOD and do not
              represent the views of OHMYFOOD or its affiliates. OHMYFOOD shall
              have no liability for Ratings and Reviews or for any claims of
              economic loss resulting from such Ratings and Reviews. Because we
              strive to maintain a high level of integrity with respect to
              Ratings and Reviews posted or otherwise made available through the
              Services, you acknowledge and agree that: (i) you will base any
              Rating or Review on first-hand experience with the Merchant or
              business; (ii) you will not provide a Rating or Review for any
              Merchant or business for which you have an ownership interest,
              employment relationship, or other affiliation or for any
              competitor of such a Merchant or business; (iii) you will not
              submit a Rating or Review in exchange for payment, free food
              items, or other benefits from a Merchant or business; (iv) for
              United States Orders, any Rating or Review you submit will comply
              with the Federal Trade Commission’s Guides Concerning the Use of
              Endorsements and Testimonials in Advertising; (v) for Canada
              Orders, any Rating or Review you submit will comply with the
              Competition Bureau’s Enforcement Guidelines and Advertising
              Standards Canada&apos;s Interpretation Guideline for Testimonials,
              Endorsements and Reviews; (vi) your Rating or Review will comply
              with the terms of this Agreement; (vii) we may decide to not
              publish, display, or otherwise make available your Rating or
              Review for any reason in our sole discretion; (viii) any Rating or
              Review you submit will comply with our Content Guidelines ; (ix) a
              Rating, Review, or photo displayed in connection with a restaurant
              may reflect an in-person dining experience; and (x) a Rating,
              Review, or photo may not have originally been submitted on the
              OHMYFOOD platform and/or may not have been submitted by a OHMYFOOD
              customer. If we determine, in our sole discretion, that any Rating
              or Review could diminish the integrity of the Ratings and Reviews
              or otherwise violates this Agreement, we may remove such Rating or
              Review without notice and take any additional action, in
              OHMYFOOD’s sole discretion, as we deem necessary or appropriate.
                        </li>
                    </ul>
                </section>

                {/* Section 9 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>9. Communications with OHMYFOOD</h2>
                    <p className='terms-text'>
            By creating a OHMYFOOD account or using the Technology or Services,
            you agree to: (a) accept and receive communications from or on
            behalf of OHMYFOOD, Contractors, Merchants, partners, and/or third
            parties providing services to you or OHMYFOOD, including via email,
            text message, direct message, chat, and calls, to the contact
            information you provide to OHMYFOOD when registering an account or
            using the Technology or Services; and (b) receive communications via
            push notification or in-app messages in the OHMYFOOD or Caviar
            mobile application. Further, you understand and agree that you may
            receive communications (e.g., calls, text messages, etc.) that are
            generated by an automatic telephone dialing system, and/or which
            will deliver prerecorded or automated messages, sent by or on behalf
            of OHMYFOOD and Merchants (e.g., Merchants facilitating the delivery
            of your order), including but not limited to communications
            concerning orders you place through your account on the Services.
            For clarification, you acknowledge and agree that you will receive
            communications from Contractors who are facilitating your receipt of
            the benefit of the Services (including multimedia messaging service
            (“
                        <strong>MMS</strong>”) messages to confirm the delivery of your
            order). Message and data rates may apply and message frequency may
            vary. The communications in this Section 9 may include, without
            limitation, commercial or marketing messages (see Section 24 for
            information about consumer marketing text messages), transactional
            or relationship messages (e.g., messages about the availability of
            our services (e.g., interruptions in service), security and/or fraud
            (e.g., password reset messages), safety, responses to communications
            initiated by you, updates to policies/legal agreements (e.g.,
            privacy policies, terms of service)), newsletters, and messages
            relating to research, political advocacy, or customer support (those
            initiated by you and by us). You acknowledge that receiving
            commercial or marketing messages or calls is not a requirement or
            condition for you to use the Services. For purposes of clarity, any
            message (including text message) or call you may receive from us, a
            Merchant, or a Contractor regarding an order is a transactional
            message, not a commercial, marketing, or promotional message or
            call. If there are changes to your contact information (e.g., email
            address, phone number), you agree to update your account to help
            prevent or limit OHMYFOOD inadvertently communicating with someone
            else.
                    </p>
                    <p className='terms-text'>
            The opt-out options for communications are set out below. If you opt
            out of receiving communications via one channel, that opt out will
            only apply to the specific channel for which the opt out is
            submitted (e.g., if you opt out of receiving email communications,
            it will not apply to any other channels through which communications
            can be sent). Please see the following for more information:
                        <ul className='bulleted-list'>
                            <li>
                For email communications that permit opting out (e.g.,
                commercial/marketing messages), there is an opt-out mechanism in
                the messages. For transactional or relationship email messages,
                the only opt-out option is to delete your account.
                            </li>
                            <li>
                To opt out of receiving transactional or relationship text
                messages (e.g., order updates), you can: (x) toggle or slide off
                this type of message in your account settings; (y) reply “STOP”
                to a text message you receive; or (z) send “STOP” to 87424. For
                MMS messages sent by Contractors to confirm the delivery of your
                order, you cannot opt out of receiving these messages unless you
                stop using the Services and delete your account.
                            </li>
                            <li>
                For phone calls, you can submit a request to be added to
                OHMYFOOD’s internal do not call list by making the request
                during the call or contacting OHMYFOOD Support at (855)
                431-0459.
                            </li>
                            <li>
                For push notifications, you can toggle or slide off these
                notifications in the mobile application.
                            </li>
                            <li>
                To opt out of all communications, the only option is to delete
                your account.
                            </li>
                        </ul>
                    </p>
                    <p className='terms-text'>
            Review the OHMYFOOD{' '}
                        <a href='/privacy-policy' className='inline-link'>
              Privacy Policy
                        </a>{' '}
            for more information about OHMYFOOD’s privacy practices, contact
            information, and opt-out options.
                    </p>
                    <p className='terms-text'>
            You authorize your wireless carrier to use or disclose information
            about your account and your wireless device, if available, to
            OHMYFOOD or its service provider for the duration of your business
            relationship, solely to help them identify you or your wireless
            device and to prevent fraud. See our{' '}
                        <a href='/privacy-policy' className='inline-link'>
              Privacy Policy
                        </a>{' '}
            for how we treat your data.
                    </p>
                </section>

                {/* Section 10 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>10. Electronic Records</h2>
                    <p className='terms-text'>
            By creating a OHMYFOOD account or using the Technology or Services,
            you consent to the use of electronic records. You also agree that
            all terms and conditions, agreements, notices, disclosures, and
            other communications that OHMYFOOD provides to you electronically
            satisfy any legal requirement for such communications to be in
            writing. You agree to keep your contact information, including email
            address, current. This paragraph does not affect your statutory
            rights.
                    </p>
                    <p className='terms-text'>
            To view and retain a copy of this Agreement, you will need (a) a
            device (such as a computer or mobile phone) with a web browser and
            Internet access, and (b) either a printer or storage space on such
            device.
                    </p>
                </section>

                {/* Section 11 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>11. Intellectual Property Ownership</h2>
                    <p className='terms-text'>
            OHMYFOOD alone (and its licensors, where applicable) shall own all
            right, title, and interest, including all related intellectual
            property rights, in and to the Technology and the Services. This
            Agreement is not a sale and does not convey to you any rights of
            ownership in or related to the Technology or the Services, or any
            intellectual property rights owned by OHMYFOOD. OHMYFOOD names,
            OHMYFOOD logos, and the product names associated with the Technology
            and Services are trademarks of OHMYFOOD or third parties, and no
            right or license is granted to use them. You agree that you will not
            remove, alter, or obscure any copyright, trademark, service mark, or
            other proprietary rights notices incorporated in or accompanying the
            Technology or the Services.
                    </p>
                </section>

                {/* Section 12 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>12. Payment Terms</h2>
                    <p className='terms-text'>
            (a)<strong>Prices and Charges.</strong> You understand that: (i) the
            prices for menu or other items displayed through the Services may
            differ from the prices offered or published by Merchants for the
            same menu or other items and/or from prices available at third-party
            websites and that such prices may not be the lowest prices at which
            the menu or other items are sold and may change at any time without
            notice; (ii) OHMYFOOD has no obligation to itemize its costs,
            profits, or margins when publishing such prices; and (iii) pricing
            may change at any time, in the discretion of OHMYFOOD or the
            Merchant (depending on which party sets the given price). For
            certain transactions, the subtotals shown at checkout are estimates
            that may be higher or lower depending on the final in-store totals.
            In those situations, OHMYFOOD reserves the right to temporarily
            authorize or place a hold on your payment method for an amount that
            may be greater than the amount shown at checkout and to charge your
            payment method the final price after checkout. You are liable for
            all transaction taxes (other than taxes based on OHMYFOOD’s income),
            including sales tax, use tax, goods and services tax, and other
            transaction taxes if applicable, on the Services provided under this
            Agreement (which, for the avoidance of doubt, includes any fees
            OHMYFOOD charges for OHMYFOODPass subscriptions). If transaction
            taxes, including sales tax, use tax, goods and services tax, and
            other transaction taxes, are applicable, OHMYFOOD reserves the right
            to charge you additional amounts on account of such taxes. For
            Australia and New Zealand Orders, all dollar amounts (including any
            fees, charges, prices, or amounts payable or receivable) displayed
            through the Services are stated on a goods and services
            tax-inclusive (if any) basis, except where noted; goods and services
            tax will be payable in addition to and at the same time as any
            amounts payable under these Terms. In the event that the charge to
            your payment method may incorrectly differ from the total amount,
            including subtotal, fees, and gratuity, displayed to you at checkout
            and/or after gratuity is selected, OHMYFOOD reserves the right to
            make an additional charge to your payment method after the initial
            charge so that the total amount charged is consistent with the total
            amount displayed to you at checkout and/or after gratuity is
            selected. All payments will be processed by OHMYFOOD and/or its
            payments processor, using the preferred payment method designated in
            your account. If your payment details change, you or your card
            provider may provide us with updated payment details. We may use
            these new details or details from other payment methods on file in
            order to help prevent any interruption to your use of the Services.
            This includes our right to charge any payment method on file if your
            initial form of preferred payment fails. It is your responsibility
            to keep your billing information up to date.
                    </p>
                    <p className='terms-text'>
            (b)<strong>Strikethrough Pricing (United States Orders).</strong>
            This Section 12(b) applies to United States Orders.OHMYFOOD may use
            strikethrough pricing for certain items (for example, when
            presenting a discount or promotional price for items). OHMYFOOD does
            not represent that the strikethrough price was the regular or former
            price of items for any particular period of time and the time period
            may vary widely depending on the items. OHMYFOOD may also rely on
            Merchants or a third party to provide information about the regular
            or former price of items offered by those Merchants or a third
            party, and OHMYFOOD’s strikethrough price therefore may represent
            the price that OHMYFOOD, a Merchant, or a third party offered the
            item for sale for some period of time. The strikethrough price may
            also be an introductory price that was offered for a short period of
            time. Unless otherwise specified, the strikethrough price represents
            a non-member discount to the extent the Merchant has a membership
            program.
                    </p>
                    <h3 className='terms-subheading'>(c) Refunds</h3>
                    <ul className='list-inside'>
                        <li>
              (i)<strong>United States, Canada, and New Zealand Orders.</strong>
              This Section 12(c)(i) applies to United States, Canada, and New
              Zealand Orders. Charges paid by you for completed and delivered
              orders, or for orders confirmed by a Merchant, are final and
              non-refundable. OHMYFOOD has no obligation to provide refunds or
              credits but may grant them gratuitously at OHMYFOOD’s sole
              discretion in each case. You may be required to provide
              identification information and/or a signature upon pick up and/or
              receipt of certain orders, as communicated at the time you place
              your order; if you fail to provide the required identification
              information or signature for such an order, you agree and
              acknowledge that we will not honor any claim that your order was
              not delivered and you may be subject to a non-refundable
              Undeliverable Item Fee.
                            <strong>
                For New Zealand Orders, nothing in this Section 12(c)(i) takes
                away from any rights you may have under the Consumer Guarantees
                Act 1993 or the Fair Trading Act 1986.
                            </strong>
                        </li>
                        <li>
              (ii)<strong>Australia Orders.</strong> This Section 12(c)(ii)
              applies to Australia Orders. For orders placed with Merchants, to
              the extent permitted by law: (A) charges paid by you for completed
              and delivered orders are final and OHMYFOOD has no obligation to
              provide refunds or credits; and (B) you may be required to provide
              identification information and/or a signature upon pick up and/or
              receipt of certain orders, as communicated at the time you place
              your order; if you fail to provide the required identification
              information or signature for such an order, you agree and
              acknowledge that we will not honor any claim that your order was
              not delivered and you may be subject to a non-refundable
              Undeliverable Item Fee. Nothing in this clause takes away from any
              rights you may have under the Australian Consumer Law. The
              Merchant will be liable for any major or minor problems with
              Merchant orders for which they are responsible, though OHMYFOOD
              may assist, at its sole discretion, with remedies such as refunds
              or credits.
                        </li>
                    </ul>
                    <p className='terms-text'>
            In order to make a claim for a refund or credit, please follow the
            procedures set out in the Technology or Services.
                    </p>
                    <p className='terms-text'>
            (d)<strong>Promotional Offers and Credits.</strong>OHMYFOOD, at its
            sole discretion, may make promotional offers with different features
            and different pricing to any User. These promotional offers are
            subject to the terms of this Agreement and may be valid only for
            certain Users as indicated in the offer. You agree that promotional
            offers: (i) may only be used by the intended audience, for the
            intended purpose, and in a lawful manner; (ii) may not be
            duplicated, sold, or transferred in any manner, or made available to
            the general public, unless expressly permitted by OHMYFOOD; (iii)
            are subject to the specific terms that OHMYFOOD establishes for such
            promotional offer; (iv) cannot be redeemed for cash or cash
            equivalent; and (v) are not valid for use after the date indicated
            in the offer or in OHMYFOOD’s Promotional Offers and Credits Terms
            and Conditions , which is, to the extent permitted by applicable
            law, incorporated in this Agreement by reference. OHMYFOOD reserves
            the right to withhold or deduct credits or benefits obtained through
            a promotion, or to charge additional amounts that would have applied
            to the transaction had the promotion not applied, in the event that
            OHMYFOOD determines or believes on reasonable grounds that the
            redemption of the promotion or receipt of the credit or benefit was
            in error, fraudulent, illegal, or in violation of the applicable
            promotion terms or this Agreement. Where required by law, which may
            include in the Province of Québec, we will provide you with written
            notice of any such withholding or deduction, including the reasons
            which led us to take such action. OHMYFOOD reserves the right to
            modify or cancel an offer at any time. OHMYFOOD’s Promotional Offers
            and Credits Terms and Conditions apply to all promotional offers.
            You agree that we may change the Promotional Offers and Credits
            Terms and Conditions at any time. OHMYFOOD may also offer gratuitous
            credits, which can be used for the Services; such credits include,
            without limiting the foregoing, any credits earned through the
            OHMYFOOD consumer referral program (the “
                        <strong>Referral Program</strong>”). The Referral Program is
            governed by OHMYFOOD’s Referral Program Terms and Conditions , which
            are incorporated herein by reference. You agree that we may change
            the Referral Program Terms and Conditions or terminate the Referral
            Program at any time. Any credit issued by OHMYFOOD under this
            Section 12(d) is valid for 6 months from the date of issue, except
            as otherwise stated in the promotional offer or to the extent
            prohibited under applicable law, and may not be redeemed for cash or
            cash equivalent; however, your credits may expire earlier if your
            account is deactivated or deleted. Upon expiration, credits will be
            removed from your account. Expired credits are no longer redeemable
            and cannot be used towards any order. Credits issued to a User’s
            OHMYFOOD or Caviar account may only be used on that respective
            brand’s Services.
                    </p>
                    <p className='terms-text'>
            (e)<strong>Fees for Services.</strong>OHMYFOOD may change the fees
            that OHMYFOOD charges you as we deem necessary or appropriate for
            our business, including but not limited to Delivery Fees, Service
            Fees, Small Order Fees, Expanded Range Fees, Regulatory Response
            Fees, and Surge Fees. OHMYFOOD may offer different pricing to
            customers based on a variety of factors, including but not limited
            to geographic areas or usage. OHMYFOOD may also charge you
            additional fees as required by law. Further, OHMYFOOD may charge
            Merchants fees on orders that you place through the Services,
            including commissions and other fees, and may change those Merchant
            fees as we deem necessary or appropriate for our business or to
            comply with applicable law.
                        <strong>
              OHMYFOOD may charge you a Service Fee for the convenience of
              ordering through the OHMYFOOD platform. None of the Service Fee,
              Delivery Fee, Small Order Fee, Surge Fee, or any other fee charged
              to you by OHMYFOOD is for any right to access, install, or use any
              Technology.
                        </strong>
                    </p>
                    <h3 className='terms-subheading'>(f) No Additional Charges by You</h3>
                    <p className='terms-text'>
            (f)<strong>Gift Cards.</strong> Gift cards are governed by
            OHMYFOOD’s Gift Card Terms and Conditions , which are incorporated
            herein by reference. Except as provided below, gift cards may be
            redeemable towards eligible orders placed on www.OMyFood.io or in
            the OHMYFOOD mobile application or, for United States Orders only,
            on www.trycaviar.com or in the Caviar mobile application. But if you
            have a gift card that was purchased and used before September 15,
            2020 in the United States, you must use any remaining balance of
            that gift card on the service (Caviar or OHMYFOOD) where the card
            was first redeemed. Gift cards are issued by the following entities:
            OHMYFOOD Giftcards LLC in the United States; OHMYFOOD Technologies
            Canada, Inc. in Canada; OHMYFOOD Technologies Pty Ltd in Australia;
            and OHMYFOOD Technologies New Zealand in New Zealand. Gift cards are
            not redeemable for cash except when required by applicable law. Once
            a gift card is redeemed, the amount of the gift card is converted
            into credits linked to your account, and such credits may be used
            towards eligible OHMYFOOD or, if applicable, Caviar orders. While
            credits from gift cards do not expire, you will lose access to such
            credits if your account is deactivated or deleted. Credits issued to
            a User’s OHMYFOOD or Caviar account may only be used on that
            respective brand’s Services.
                    </p>
                    <p className='terms-text'>
            (g)
                        <strong>
              SNAP/EBT (United States Orders but Excluding Puerto Rico Orders).
                        </strong>
            This Section 12(g) applies to United States Orders (but excluding
            Puerto Rico Orders). OHMYFOOD permits customers in the United States
            (but excluding Puerto Rico) to purchase Supplemental Nutrition
            Assistance Program (“<strong>SNAP</strong>”) eligible items from
            select Merchants using a valid Electronic Benefits Transfer (
                        <strong>EBT</strong>”) card. For any transactions involving use of
            your SNAP EBT funds, a credit or debit card must also be linked to
            your OHMYFOOD account to pay for any fees, taxes, delivery tips, and
            any other items you purchase that are not SNAP-eligible. You have
            the option to view SNAP-eligible items on the OHMYFOOD platform by
            using a “SNAP” filter. SNAP-eligible items will also have a “SNAP”
            tag on their respective item details pages. By providing OHMYFOOD
            with your SNAP EBT card information, you represent and warrant that
            (i) you are legally authorized to use the SNAP EBT card provided;
            (ii) your SNAP EBT card is current and valid; and (iii) you
            authorize OHMYFOOD to use your SNAP EBT card information for
            transactions involving use of your SNAP EBT benefits. OHMYFOOD
            cannot accept EBT cash at this time.
                    </p>

                    <p className='terms-text'>
            (h)
                        <strong>
              Invoice or Other Taxable Supply Information (Australia, Canada,
              and New Zealand Orders).
                        </strong>
            This Section 12(h) applies to Australia, Canada, and New Zealand
            Orders. A tax invoice (or alternative taxable supply information if
            and when permitted to be issued under Australia, Canada, or New
            Zealand tax law instead of a tax invoice) for OHMYFOOD fees will be
            made available by OHMYFOOD to you when OHMYFOOD is legally required
            to do so, or otherwise at OHMYFOOD’s sole discretion, upon you
            having submitted a request for a tax invoice (or tax information) at
            our Customer Support page. You agree that invoices (or alternative
            taxable supply information) will only be made in electronic form. In
            accordance with applicable laws, for tax invoices (or alternative
            taxable supply information) for menu items, you should contact the
            relevant Merchant(s).
                    </p>

                    <p className='terms-text'>
            (i)<strong> Checkout Merchants.</strong> OHMYFOOD provides certain
            checkout-related services to third-party merchants outside of the
            OHMYFOOD platform to facilitate the completion of transactions with
            such merchants (“<strong>Checkout Merchants</strong>”). If you are
            completing a transaction directly with a Checkout Merchant outside
            of the OHMYFOOD platform and we determine that you are a registered
            OHMYFOOD User, we may share certain information about you, including
            loyalty or rewards information, OHMYFOODPass subscription status,
            and/or payment card, payment method, billing, and contact
            information, with the Checkout Merchant for the purpose of
            facilitating the transaction. The processing of such information by
            the Checkout Merchant is subject to the Checkout Merchant’s privacy
            policy, terms of service, and/or other applicable terms. OHMYFOOD is
            not a party to any such transaction and OHMYFOOD is not liable or
            responsible for the Checkout Merchant’s processing of your
            information. Any questions or disputes regarding such transactions
            or the processing of your information by the Checkout Merchant
            should be directed to the Checkout Merchant or your payment
            provider.
                    </p>
                </section>

                {/* Section 13 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>13. OHMYFOODPass Subscriptions</h2>
                    <p className='terms-text'>
                        <strong>(a) General.</strong> OHMYFOODPass is an automatically
            renewing subscription requiring recurring payments until canceled. A
            OHMYFOODPass subscription grants you access to certain benefits (“
                        <strong>OHMYFOODPass Benefits</strong>”) on eligible orders placed
            through the Services for eligible Merchants with a minimum subtotal
            (excluding taxes, fees, and tips) as indicated through the Services.
            OHMYFOODPass Benefits include reduced fees for United States Orders
            and Canada Orders and $0 delivery fees for Australia Orders and New
            Zealand Orders. For certain OHMYFOOD orders that may have
            alternative fee structures (for example, a flat OHMYFOOD fee),
            OHMYFOODPass Benefits may vary. OHMYFOOD reserves the right to
            change whether a Merchant is eligible for OHMYFOODPass at any time
            with or without notice. If you are a United States Consumer
            (excluding a United States Consumer whose primary residence is in
            Puerto Rico), you acknowledge that you are purchasing a OHMYFOODPass
            subscription exclusively from OHMYFOOD, Inc. OHMYFOODPass orders are
            subject to delivery driver and geographic availability, and taxes
            may apply to the cost of the items you order and/or to fees charged.
            You may provide an optional gratuity. Service Fees and other fees
            may apply. We reserve the right to add and modify fees that may
            apply to your OHMYFOODPass orders. Your OHMYFOODPass Benefits will
            extend to both OHMYFOOD and Caviar (if applicable) when you register
            for a OHMYFOODPass subscription.
                    </p>

                    <p className='terms-text'>
            OHMYFOODPass is offered for a monthly or yearly fee payable at the
            start of the relevant period. By signing up for OHMYFOODPass, you
            agree that: (i) you will be charged your first OHMYFOODPass
            subscription fee and any applicable taxes (such as sales tax, use
            tax, goods and services tax, and other transaction taxes) on the
            date you purchase your OHMYFOODPass subscription or, if your
            subscription includes a free trial, on the day after your free trial
            ends; (ii) you authorize OHMYFOOD and its service providers to store
            your payment method for the purpose of executing future OHMYFOODPass
            auto-renewal transactions; (iii) UNLESS YOU CANCEL, BY DEFAULT (AND
            WITH PRIOR NOTICE ONLY TO THE EXTENT REQUIRED BY APPLICABLE LAW),
            YOUR OHMYFOODPASS SUBSCRIPTION WILL AUTOMATICALLY RENEW AT THE END
            OF THE THEN-CURRENT SUBSCRIPTION PERIOD; and (iv) AT THE TIME OF
            RENEWAL, OHMYFOOD WILL AUTOMATICALLY CHARGE THE THEN-CURRENT
            OHMYFOODPASS SUBSCRIPTION FEE AND ANY APPLICABLE TAXES TO AN
            ELIGIBLE PAYMENT METHOD THAT WE HAVE ON FILE FOR YOU. If your
            payment details change, your card provider may provide us with
            updated payment details. We may use these new details or details
            from other payment methods on file in order to help prevent any
            interruption to your OHMYFOODPass subscription. This includes our
            right to charge any payment method on file if your initial form of
            preferred payment fails. It is your responsibility to keep your
            billing information up to date. If any subscription fee is not paid
            in a timely manner or your transaction cannot be processed, we
            reserve the right to suspend, disable, cancel, or terminate your
            access to the Services or your OHMYFOODPass subscription. Where
            required by law, which may include in the Province of Québec, we
            will provide you with written notice of the suspension, disabling,
            cancellation, or termination of your access to the Services or your
            OHMYFOODPass subscription, including the reasons which led us to
            take such action. You will be responsible for paying all past due
            amounts.
                    </p>

                    <p className='terms-text'>
            (b)<strong>Corporate OHMYFOODPass Subscriptions.</strong>
            Notwithstanding any other provision in these Terms, you may be
            eligible for a complimentary OHMYFOODPass subscription when your
            employer registers for a corporate OHMYFOODPass subscription. If you
            have a complimentary OHMYFOODPass subscription through your
            employer, your account will begin and end in accordance with the
            terms of your employer’s corporate subscription unless your
            subscription is otherwise canceled. To receive the subscription
            benefits, you must register using your corporate email address and
            be an authorized User added by your employer, and then click or tap
            the activation button.
                    </p>

                    <p className='terms-text'>
            (c)<strong>OHMYFOODPass Student Plan.</strong> OHMYFOOD may offer
            OHMYFOODPass student plan subscriptions at a discounted price on
            either a monthly or annual basis to qualifying individuals who meet
            the eligibility requirements stated at sign up, including but not
            limited to current enrollment at an accredited college or
            university. Individuals may be required to provide documentation so
            that OHMYFOOD may verify their eligibility for a OHMYFOODPass
            student plan. OHMYFOODPass student plan subscriptions are subject to
            this Agreement and OHMYFOOD’s Promotional Offers and Credits Terms
            and Conditions.
                    </p>

                    <p className='terms-text'>
                        <strong>(d) Trial or Promotional Subscriptions.</strong> From time
            to time, OHMYFOOD may offer some customers trial or other
            promotional subscriptions to OHMYFOODPass, whether directly from
            OHMYFOOD or in partnership with a third party. Such trial or
            promotional subscriptions are available only for Users who have not
            previously subscribed to OHMYFOODPass (whether on a free or paid
            plan) and are subject to this Agreement and OHMYFOOD’s Promotional
            Offers and Credits Terms and Conditions except as otherwise stated
            in the promotional offer.If you do not cancel your free trial or
            promotional subscription within the trial or promotional pricing
            period, you agree to purchase a paid OHMYFOODPass subscription at
            the then-current fee. When your free trial or promotional pricing
            period has expired, your subscription will automatically convert
            into a paid, automatically renewing OHMYFOODPass subscription, and
            OHMYFOOD will bill you the applicable fee (plus applicable taxes,
            such as sales tax, use tax, goods and services tax, and other
            transaction taxes) unless you cancel. If you cancel OHMYFOODPass
            before the trial period has expired, OHMYFOOD will not charge you
            for the OHMYFOODPass subscription. If you purchase a OHMYFOODPass
            subscription with a promotional code, each time your OHMYFOODPass
            subscription renews, you will be charged the full billing amount.
            Only one trial or promotional subscription is available per
            household. If your OHMYFOODPass subscription is ever terminated for
            any reason, you shall not be eligible for a free trial on any
            subsequent OHMYFOODPass subscription.
                    </p>

                    <p className='terms-text'>
                        <strong>(e) OHMYFOODPass Gift Subscriptions.</strong> OHMYFOOD may
            offer customers the opportunity to purchase OHMYFOODPass gift
            subscriptions (“<strong>OHMYFOODPass Gift Subscriptions</strong>”)
            and then send these OHMYFOODPass Gift Subscriptions to other
            customers to redeem (“<strong>Gift Subscription Recipients</strong>
            ”). Such OHMYFOODPass Gift Subscriptions are subject to this
            Agreement and the OHMYFOODPass Gift Membership Terms and Conditions.
            OHMYFOODPass Gift Subscriptions can only be purchased and redeemed
            by Users who have or create a valid OHMYFOOD account with a valid
            form of accepted payment on file. A OHMYFOODPass Gift Subscription
            entitles the Gift Subscription Recipient to a OHMYFOODPass
            subscription for the length of time identified in the OHMYFOODPass
            Gift Subscription confirmation (the “
                        <strong>OHMYFOODPass Gift Subscription Period</strong>”).
                    </p>
                    <p className='terms-text'>
            OHMYFOODPass Gift Subscriptions are issued by the following
            entities: OHMYFOOD Giftcards LLC in the United States; OHMYFOOD
            Technologies Canada, Inc. in Canada; OHMYFOOD Technologies Australia
            Pty Ltd in Australia; and OHMYFOOD Technologies New Zealand in New
            Zealand.
                    </p>
                    <p className='terms-text'>
            OHMYFOODPass Gift Subscriptions cannot be redeemed by OHMYFOODPass
            subscribers currently enrolled in any free, paid, or discounted
            partnership subscription plan (“
                        <strong>Excluded Subscription Plans</strong>”). Any Gift
            Subscription Recipients of a OHMYFOODPass Gift Subscription
            currently enrolled in an Excluded Subscription Plan may choose to
            transfer their OHMYFOODPass Gift Subscription to another customer.
            For Gift Subscription Recipients enrolled in an eligible existing
            paid OHMYFOODPass subscription at the time of redemption of a
            OHMYFOODPass Gift Subscription, such eligible existing paid
            OHMYFOODPass subscription will continue through the end of the Gift
            Subscription Recipient’s current OHMYFOODPass billing cycle before
            the OHMYFOODPass Gift Subscription will be applied. For Gift
            Subscription Recipients enrolled in an eligible existing
            OHMYFOODPass subscription currently in a free period at the time of
            redemption of a OHMYFOODPass Gift Subscription, the OHMYFOODPass
            Gift Subscription will be applied immediately upon redemption and
            any unused days in the previous free period will be forfeited.
                    </p>
                    <p className='terms-text'>
            For all Gift Subscription Recipients, after the OHMYFOODPass Gift
            Subscription Period ends, that subscription will automatically
            convert into a paid monthly OHMYFOODPass subscription, and OHMYFOOD
            will charge the Gift Subscription Recipient the applicable monthly
            fee to the preferred payment method designated in the Gift
            Subscription Recipient’s OHMYFOOD account. All purchases of
            OHMYFOODPass Gift Subscriptions are final and non-refundable.
                    </p>

                    <p className='terms-text'>
                        <strong>(f) Cancellations.</strong> When you cancel a OHMYFOODPass
            subscription, you cancel only future charges associated with your
            OHMYFOODPass subscription. You may initiate your cancellation at any
            time through the Services, but the cancellation will become
            effective at the end of your current subscription period.
            Instructions on how to cancel are available here. You must cancel at
            least one (1) day before the next-scheduled subscription renewal
            date to avoid being charged for the next subscription period (for
            example, if the renewal date is January 10, you must cancel by
            11:59:59 pm on January 9).
                    </p>
                    <p className='terms-text'>
            If you participated in a free trial or other promotional
            subscription period for OHMYFOODPass, you may cancel within the
            first 48 hours of your first paid OHMYFOODPass subscription period
            and receive a full refund of your OHMYFOODPass fee (as applicable).
                    </p>
                    <p className='terms-text'>
            For both monthly and annual subscribers, if you cancel your
            OHMYFOODPass subscription within the first 48 hours of your first
            subscription period and have not placed a OHMYFOODPass-eligible
            order during that period, OHMYFOOD may, in its sole discretion,
            refund your OHMYFOODPass fee. If we issue a refund, credit, or
            discount, we are under no obligation to issue the same or similar
            refund in the future.
                    </p>
                    <p className='terms-text'>
            UNLESS YOU ARE A CANADA CONSUMER WHO RESIDES IN THE PROVINCE OF
            QUÉBEC AND EXCEPT AS OTHERWISE STATED HEREIN OR REQUIRED BY
            APPLICABLE LAW (INCLUDING THE AUSTRALIAN CONSUMER LAW FOR AUSTRALIAN
            CONSUMERS AND THE CONSUMER GUARANTEES ACT 1993 OR FAIR TRADING ACT
            1986 FOR NEW ZEALAND CONSUMERS), YOUR SUBSCRIPTION FEE IS
            NONREFUNDABLE and if you cancel your OHMYFOODPass subscription, you
            will not receive a refund, but you can continue to enjoy the
            OHMYFOODPass Benefits through the end of your then-current
            subscription period. For Canada Consumers who reside in the Province
            of Québec, if you cancel your annual subscription, you may request a
            prorated refund by calling Support at 855-431-0459.
                    </p>

                    <p className='terms-text'>
            (g)<strong>OHMYFOODPass Benefits for Certain Cardmembers.</strong>
                    </p>
                    <p className='terms-text'>
            (i)
                        <strong>
              Chase Cardmembers (United States Only but Excluding Puerto Rico).
                        </strong>
            Chase cardmembers in the United States (but excluding Puerto Rico)
            are eligible for certain OHMYFOODPass benefits on both OHMYFOOD and
            Caviar when an eligible Chase credit card is added to either
            account. The specific benefits depend upon which Chase credit card
            is added to your account. These benefits are subject to this
            Agreement and OHMYFOOD’s Promotional Offers and Credits Terms and
            Conditions as well as the following card-specific terms:
                    </p>
                    <p className='terms-text'>
            Additional information about the OHMYFOODPass benefits for Chase
            cardmembers can be found at our OHMYFOODPass for Chase Cardmembers
            page.
                    </p>

                    <p className='terms-text'>
            (ii)
                        <strong>
              Mastercard Cardmembers (United States Only but Excluding Puerto
              Rico).
                        </strong>
            Eligible World and World Elite Mastercard cardmembers in the United
            States (but excluding Puerto Rico) are eligible for certain
            OHMYFOODPass benefits on both OHMYFOOD and Caviar when they sign up
            for OHMYFOODPass with their eligible World and World Elite
            Mastercard. These benefits are subject to this Agreement and
            OHMYFOOD’s Promotional Offers and Credits Terms and Conditions as
            well as the program-specific benefit disclosures available here.
                    </p>
                    <p className='terms-text'>
            (iii)<strong> RBC Cardmembers (Canada only.)</strong>RBC cardmembers
            in Canada are eligible for complimentary OHMYFOODPass on OHMYFOOD
            (length of complimentary subscription depends on which RBC credit
            card is used) when an eligible RBC credit card is added to their
            OHMYFOOD account. OHMYFOOD is responsible for OHMYFOODPass and the
            use of OHMYFOODPass through these complimentary subscriptions is
            subject to this Agreement and OHMYFOOD’s Promotional Offers and
            Credits Terms and Conditions. Eligibility for the complimentary
            OHMYFOODPass subscription for eligible RBC cardmembers and other
            offer terms are available in the OHMYFOOD/RBC Complimentary
            OHMYFOODPass Terms (English / French).Additional information about
            the OHMYFOODPass benefits for RBC cardmembers can be found at our
            OHMYFOODPass for RBC Cardmembers page.
                    </p>

                    <p className='terms-text'>
            (h)
                        <strong>
              OHMYFOODPass Student Plan with Chegg (United States Only).
                        </strong>
            Current Chegg Study or Chegg Study Pack subscribers who are at least
            18 years old, reside in the United States, and are enrolled in an
            accredited college or university in the United States are eligible
            to activate a free OHMYFOODPass Student subscription until November
            1, 2023. If you cancel your Chegg Study or Chegg Study Pack
            subscription or upon 30 days’ prior notice from OHMYFOOD, you will
            continue to be enrolled in the OHMYFOODPass for Students
            subscription and will be automatically charged the then-current
            monthly OHMYFOODPass for Students subscription fee (plus any
            applicable taxes) on a recurring basis until you cancel your
            OHMYFOODPass for Students subscription. See full Chegg x
            OHMYFOODPass Student Membership Offer terms and conditions here.
                    </p>

                    <p className='terms-text'>
            (i)
                        <strong>
              Complimentary OHMYFOODPass for Amazon Prime Members (Canada Only).
                        </strong>
            Amazon Prime members in Canada are eligible for 12 months of
            complimentary monthly OHMYFOODPass on OHMYFOOD. At the end of this
            12-month period, the complimentary OHMYFOODPass subscription will
            automatically renew as a paid monthly OHMYFOODPass plan at the
            then-current monthly fee plus applicable taxes unless you cancel
            your OHMYFOODPass subscription prior to renewal. The offer terms and
            conditions can be found here.
                    </p>

                    <p className='terms-text'>
            (j)
                        <strong>
              Complimentary OHMYFOODPass for Amazon Prime Members (Australia
              Only).
                        </strong>
            Amazon Prime members in Australia are eligible for 24 months of
            complimentary monthly OHMYFOODPass on OHMYFOOD. At the end of this
            24-month period, the complimentary OHMYFOODPass subscription will
            automatically renew as a paid monthly OHMYFOODPass plan at the
            then-current monthly fee unless you cancel your OHMYFOODPass
            subscription prior to renewal. The offer terms and conditions can be
            found here.
                    </p>

                    <p className='terms-text'>
            (k)
                        <strong>
              Max Subscription with OHMYFOODPass Annual Plan (United States
              Only).
                        </strong>
            OHMYFOODPass Annual Plan subscribers in the United States only are
            eligible to activate a Max With Ads subscription (ad-supported
            offering) at no additional cost to OHMYFOODPass Annual Plan
            subscribers. These subscribers also have the option to upgrade to a
            Max Ad-Free subscription for an additional monthly fee at a
            discounted rate (plus applicable taxes), which will be published at
            the time of sign up. The Max With Ads and Max Ad-Free subscriptions
            are subject to the offer terms and conditions found here.
                    </p>

                    <p className='terms-text'>
            (l)<strong>Updates and Changes.</strong>OHMYFOOD does not represent
            or warrant that particular OHMYFOODPass benefits or features will be
            offered indefinitely and reserves the right to, in its sole
            discretion, change the fees or alter the features and benefits
            associated with a OHMYFOODPass subscription. If OHMYFOOD changes the
            monthly or annual fee charged for a OHMYFOODPass subscription,
            OHMYFOOD will notify you and provide you with the opportunity to
            cancel your subscription before your OHMYFOODPass subscription is
            renewed for another subscription term. If you do not wish to
            continue subscribing with the new subscription fees, you may cancel
            your OHMYFOODPass subscription within the specified notice period.
            We may also notify you of OHMYFOODPass feature changes. Your
            continued use of the Services after a fee or feature change becomes
            effective will constitute your acceptance of the change, and any
            updated terms and conditions will apply for the remaining
            subscription term and all renewals going forward.
                    </p>

                    <p className='terms-text'>
            (m)
                        <strong>
              No Transfer or Assignments and Cancellations by OHMYFOOD.
                        </strong>
            Your OHMYFOODPass subscription cannot be transferred or assigned.
            OHMYFOOD reserves the right to accept, refuse, suspend, or cancel
            your OHMYFOODPass subscription at any time in its sole discretion.
            If OHMYFOOD cancels your OHMYFOODPass subscription, you will receive
            a refund of your subscription fee on a pro rata basis based on the
            amount of time remaining in your pre-paid subscription, unless
            OHMYFOOD terminates your account or your OHMYFOODPass subscription
            because it determines, in its sole discretion, that your actions or
            your use of the Services violates this Agreement or has harmed
            another User.
                    </p>
                </section>

                {/* Section 14 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>14. Arbitration Agreement</h2>
                    <p className='terms-text'>
                        <strong>
              THIS SECTION 14 OF THIS AGREEMENT SHALL BE REFERRED TO AS THE
              “ARBITRATION AGREEMENT.”
                        </strong>
                    </p>
                    <p className='terms-text'>
            Please read this Section 14 carefully. It requires, unless you are a
            Canada Consumer who resides in the Province of Québec, that any and
            all claims between you and OHMYFOOD be resolved by binding
            arbitration or in small claims court or tribunal. Unless you are an
            Australia Consumer and to the extent permitted by applicable law,
            this Section 14 prevents you from pursuing a class action or similar
            proceeding in any forum. Arbitration is required if your country of
            residence enforces arbitration agreements. If you are outside the
            United States, Canada, Australia, or New Zealand, but attempt to
            bring a claim in one of those countries, arbitration is required for
            determination of the threshold issue of whether this Section 14
            applies to you, as well as all other threshold determinations,
            including residency, arbitrability, venue, and applicable law. If
            your country of residence does not enforce arbitration agreements,
            the mandatory pre-arbitration dispute resolution and notification
            and prohibition on class actions or representative proceedings
            provided below still apply to the extent enforceable by law.
                    </p>
                    <p className='terms-text'>
            (a)<strong>Scope of Arbitration Agreement.</strong>This Arbitration
            Agreement shall apply, without limitation, to all claims that arose
            or were asserted before, on, or after the effective date of this
            Agreement. You agree that any dispute or claim arising out of or
            relating in any way to the subject matter of the Agreement, to your
            access or use of the Services as a User of the Services, to any
            advertising or marketing communications regarding OHMYFOOD or the
            Services, to any products or services sold or distributed through
            the Services that you received as a User of our Services, or to any
            aspect of your relationship or transactions with OHMYFOOD as a User
            of our Services (this includes, without limitation, any contract
            claim, tort claim, statutory claim, or claim for unfair
            competition), will be resolved by binding arbitration, rather than
            in court, except as otherwise required by law—such as individual
            claims for sexual assault or sexual harassment arising from use of
            the Services by United States Consumers—or as otherwise provided in
            this Arbitration Agreement. In addition, to the extent permitted by
            applicable law, either you or OHMYFOOD may seek equitable relief in
            court for infringement or other misuse of intellectual property
            rights (such as trademarks, trade dress, domain names, trade
            secrets, copyrights, and patents). Either you or OHMYFOOD may also,
            to the extent permitted by applicable law, apply to a court of
            competent jurisdiction for temporary or preliminary injunctive
            relief on the ground that without such relief the arbitration
            provided in this paragraph may be rendered ineffectual. The
            following additional jurisdiction-specific exception to the
            foregoing applies to United States, Australia, and New Zealand
            Consumers only:
                    </p>
                    <p className='terms-text'>
            (i)<strong>United States and New Zealand Consumers Only.</strong>You
            may assert claims in small claims court or tribunal if your claims
            qualify, so long as the matter remains in such court and advances
            only on an individual (non-class, non-representative) basis.
                    </p>
                    <p className='terms-text'>
            CASES HAVE BEEN FILED AGAINST OHMYFOOD—AND OTHERS MAY BE FILED IN
            THE FUTURE—THAT ATTEMPT TO ASSERT CLASS ACTION CLAIMS, AND BY
            ACCEPTING THIS ARBITRATION AGREEMENT YOU ELECT NOT TO PARTICIPATE IN
            SUCH CASES.
                    </p>
                    <p className='terms-text'>
            IF YOU AGREE TO ARBITRATION WITH OHMYFOOD, YOU ARE AGREEING IN
            ADVANCE THAT YOU WILL NOT PARTICIPATE IN OR SEEK TO RECOVER MONETARY
            OR OTHER RELIEF IN ANY SUCH CLASS, COLLECTIVE, AND/OR REPRESENTATIVE
            LAWSUIT. INSTEAD, BY AGREEING TO ARBITRATION, YOU MAY BRING YOUR
            CLAIMS AGAINST OHMYFOOD IN AN INDIVIDUAL ARBITRATION PROCEEDING. IF
            SUCCESSFUL ON SUCH CLAIMS, YOU COULD BE AWARDED MONEY OR OTHER
            RELIEF BY AN ARBITRATOR.
                    </p>
                    <p className='terms-text'>
            (b)<strong>Informal Resolution.</strong>You and OHMYFOOD agree that
            good-faith informal efforts to resolve disputes often can result in
            a prompt, low-cost, and mutually beneficial outcome. You and
            OHMYFOOD therefore agree that, before either you or OHMYFOOD demands
            or attempts to commence arbitration against the other, we will
            personally meet and confer, via telephone or videoconference, in a
            good-faith effort to resolve informally any claim covered by this
            mutual Arbitration Agreement. The informal dispute resolution
            conferences shall be individualized such that a separate conference
            must be held each time either party intends to commence individual
            arbitration; multiple individuals initiating claims cannot
            participate in the same informal telephonic dispute resolution
            conference, unless mutually agreed to by the parties. If a party is
            represented by counsel, the party’s counsel may participate in the
            conference, but both parties (you and OHMYFOOD) shall also fully
            participate in the conference. The party initiating the claim must
            give notice to the other party in writing of their intent to
            initiate an informal dispute resolution conference, which shall
            occur within 60 days after the other party receives such notice,
            unless an extension is mutually agreed upon by the parties. To
            notify OHMYFOOD that you intend to initiate an informal dispute
            resolution conference, email Informal.Resolution@OHMYFOOD.com,
            providing your name, telephone number associated with your OHMYFOOD
            account (if any), the email address associated with your OHMYFOOD
            account, and a description of your claim. In the interval between
            the party receiving such notice and the informal dispute resolution
            conference, the parties shall be free to attempt to resolve the
            initiating party’s claims. The statute of limitations and any filing
            fee deadlines shall be tolled while the parties engage in the
            informal dispute resolution process required by this paragraph.
                    </p>
                    <p className='terms-text'>
            Engaging in an informal dispute resolution conference is a
            requirement that must be fulfilled before commencing arbitration. An
            arbitration shall be dismissed if it was filed without fully and
            completely complying with these informal dispute resolution
            procedures. If an arbitration is dismissed because a party willfully
            failed to comply with these informal dispute resolution procedures,
            the arbitrator may order the non-compliant party to pay any
            arbitration filing fees and costs incurred by the other party.
                    </p>
                    <p className='terms-text'>
            (c)<strong>Arbitration Rules and Forum</strong>
                    </p>
                    <p className='terms-text'>
            (i)<strong>United States Consumers Only.</strong>This Arbitration
            Agreement is governed by the Federal Arbitration Act (“
                        <strong>FAA</strong>”) in all respects. If for whatever reason the
            rules and procedures of the FAA cannot apply, the state law
            governing arbitration agreements in the state in which you reside
            shall apply. Before a party may begin an arbitration proceeding,
            that party must send notice of an intent to initiate arbitration and
            certify completion of the informal dispute resolution conference
            pursuant to Section 14(b). If this notice is being sent to OHMYFOOD,
            it must be sent by email to the counsel who represented OHMYFOOD in
            the informal dispute resolution process, or if there was no such
            counsel, then by mail to General Counsel, at 303 2nd Street, Suite
            800, San Francisco, CA, 94107.
                    </p>
                    <p className='terms-text'>
            If you reside in California (“<strong>California Consumer</strong>
            ”), the arbitration will be conducted by ADR Services, Inc. under
            its rules and pursuant to the terms of this Agreement. If you reside
            outside of California (“<strong>Non-California Consumer</strong>”),
            the arbitration will be conducted by National Arbitration and
            Mediation (“<strong>NAM</strong>”) under its rules and pursuant to
            the terms of this Agreement. Once the notice certifying completion
            of the informal dispute resolution conference has been served, the
            party seeking to arbitrate must then file their arbitration demands
            with ADR Services, Inc. or NAM, depending on the location of
            residence as described above. If the arbitration is filed with a
            different arbitration provider than the one required by this
            Agreement, that provider shall immediately dismiss the arbitration
            demand.
                    </p>
                    <p className='terms-text'>
            The demand must include (A) the name, telephone number, mailing
            address, and email address of the party seeking arbitration; (B) a
            statement of the legal claims being asserted and the factual bases
            of those claims; (C) a description of the remedy sought and an
            accurate, good-faith calculation of the amount in controversy,
            enumerated in United States Dollars (any request for injunctive
            relief or attorneys’ fees shall not count toward the calculation of
            the amount in controversy unless such injunctive relief seeks the
            payment of money); and (D) the signature of the party seeking
            arbitration. Disputes shall be subject to ADR Services, Inc.’s most
            current version of its Arbitration Rules, available at
            www.adrservices.com/services-2/arbitration-rules/ or by calling ADR
            Services, Inc. at 310-201-0010 (for California Consumers) or NAM’s
            most current version of its Comprehensive Rules and Procedures and,
            if applicable, its Supplemental Rules for Mass Arbitration Filings,
            available at{' '}
                        <a
                            href='https://www.namadr.com/resources/rules-fees-forms/'
                            className='inline-link'
                        >
              www.namadr.com/resources/rules-fees-forms/
                        </a>
            (for Non-California Consumers). The fees that shall apply to
            arbitrations administered by ADR Services, Inc. are set forth in ADR
            Services, Inc.’s General Fee Schedule or ADR Services, Inc.’s Mass
            Consumer Non-Employment Arbitration Fee Schedule, when applicable.
            ADR Services, Inc.’s Fee Schedules are available at
            www.adrservices.com/rate-fee-schedule/. The fees that shall apply to
            arbitrations administered by NAM are set forth in NAM’s Fees for
            Disputes Where One of the Parties Is a Consumer, available at
            www.namadr.com/resources/rules-fees-forms/. OHMYFOOD will pay the
            portion of the initial case opening fees (if any) that exceeds the
            filing fee to file the case in a court of competent jurisdiction
            embracing the location of the arbitration. Payment of all filing,
            administration, and arbitration fees will be governed by ADR
            Services, Inc.’s rules (for California Consumers) or NAM’s rules
            (for Non-California Consumers). If the arbitrator finds that you
            cannot afford to pay the filing, administrative, hearing, and/or
            other fees and cannot obtain a waiver of fees from the applicable
            arbitration provider, OHMYFOOD will pay them for you. Any finding
            that a claim or counterclaim violates the standards set forth in
            Federal Rule of Civil Procedure 11 shall entitle the other party to
            recover their attorneys’ fees, costs, and expenses associated with
            defending against the claim or counterclaim. If a party timely
            serves an offer of judgment under Federal Rule of Civil Procedure 68
            or a state or local equivalent, if applicable, and the judgment that
            the other party finally obtains is not more favorable than the
            unaccepted offer, then the other party shall pay the costs,
            including filing fees, incurred after the offer was made.
                    </p>
                    <p className='terms-text'>
            If ADR Services, Inc. (for California Consumers) or NAM (for
            Non-California Consumers) is not available or willing to arbitrate,
            the parties will mutually select an alternative arbitral forum. If,
            and only if, the parties are unable to agree on an alternative
            arbitral forum, the arbitration shall be administered by the
            American Arbitration Association (“<strong>AAA</strong>”) under its
            Consumer Arbitration Rules and, if applicable, its Supplementary
            Rules for Mass Arbitrations. If AAA is also not available or willing
            to arbitrate and the parties remain unable to agree on an
            alternative arbitral forum, either party may invoke 9 U.S.C. § 5 to
            request that a court of competent jurisdiction appoint an
            arbitrator.
                    </p>
                    <p className='terms-text'>
            To the extent there is a dispute over which arbitration provider
            shall administer the arbitration, only a court (and not an
            arbitrator or arbitration administrator) can resolve that dispute,
            and the arbitration shall be stayed until the court resolves that
            dispute. You may choose to have the arbitration conducted by video
            conference. The parties agree that all of the arbitration
            proceedings, including any discovery, hearings, and rulings, shall
            be confidential to the fullest extent permitted by applicable law.
            If at any time the arbitrator or arbitration administrator fails to
            enforce the terms of this Agreement, either party may seek to enjoin
            the arbitration proceeding in court, and the arbitration shall
            automatically be stayed pending the outcome of that proceeding.
                    </p>
                    <p className='terms-text'>
            If the arbitration involves a request for an injunction or monetary
            relief that exceeds $1,000,000 (one million dollars), then either
            party shall have the right to appeal that award to an arbitration
            appellate panel. The notice of appeal must be served, in writing, on
            the opposing party within fourteen (14) days after the award has
            become final. ADR Services, Inc. (for California Consumers) or NAM
            (for Non-California Consumers) shall administer the appeal
            consistent with the NAM Appellate Dispute Resolution Rules and
            Procedures, available at
            www.namadr.com/practice-areas/appellate-arbitration/.
                    </p>

                    <p className='terms-text'>
            (ii)
                        <strong>
              Canada Consumers Only (Except Those who Reside in the Province of
              Québec).
                        </strong>
            To the extent permitted by applicable law, this Arbitration
            Agreement is governed by the domestic arbitration act in the
            province in which you reside and ADR Institute of Canada, Inc.’s
            Arbitration Rules (adric.ca/case-administration-services/) (“
                        <strong>ADRIC Rules</strong>”) as applicable, in all respects except
            as otherwise expressly agreed herein. Before a party may begin an
            arbitration proceeding, that party must send notice of an intent to
            initiate arbitration and certify completion of the informal dispute
            resolution conference pursuant to Section 14(b). If this notice is
            being sent to OHMYFOOD, it must be sent by email to the counsel who
            represented OHMYFOOD in the informal dispute resolution process, or
            if there was no such counsel, then by mail to General Counsel,
            OHMYFOOD at 1066 West Hastings Street, Suite 2000, Vancouver BC V6E
            3X2, Canada; and legal@OHMYFOOD.com. Arbitration demands shall be
            filed with ADR Institute of Canada, Inc. (“<strong>ADRIC</strong>”)
            and shall be submitted in accordance with the ADRIC Rules and must
            include: (A) the name, telephone number, mailing address, and email
            address of the party seeking arbitration; (B) a statement of the
            legal claims being asserted and the factual bases of those claims;
            (C) a description of the remedy sought and an accurate, good-faith
            calculation of the amount in controversy (any request for injunctive
            relief or attorneys’ fees shall not count toward the calculation of
            the amount in controversy unless such injunctive relief seeks the
            payment of money); and (D) the signature of the party seeking
            arbitration. Your demand for arbitration must also be delivered to
            General Counsel, OHMYFOOD at 1066 West Hastings Street, Suite 2000,
            Vancouver BC V6E 3X2, Canada; and legal@OHMYFOOD.com.
            Notwithstanding anything to the contrary in the ADRIC Rules, the
            arbitration shall be heard by a single arbitrator (selected in
            accordance with the ADRIC Rules), who shall be a lawyer or former
            judge. The seat of the arbitration shall be the capital city of the
            province of your primary residence as of the effective date of this
            Agreement. However, at your request, the arbitration hearing may
            take place at a location that is within 45 kilometres of your
            primary residence as of the effective date of this Agreement. The
            parties agree that the arbitration may proceed virtually, and the
            arbitrator has the discretion to order a virtual arbitration at the
            request of either party. Unless applicable law provides otherwise,
            you and OHMYFOOD shall pay equal shares of the applicable filing
            fees and other similar and usual administrative costs, as are common
            to both court and administrative proceedings. OHMYFOOD shall pay any
            additional costs uniquely associated with arbitration, such as
            payment of the costs of ADRIC and the Arbitrator, as well as room
            rental or technical assistance required to support a virtual
            arbitration. The current fee schedule under the ADRIC Rules is
            available at the following link:
            adric.ca/case-administration-services/. If ADRIC is not available to
            arbitrate, the parties will mutually select an alternative arbitral
            forum.
                    </p>

                    <p className='terms-text'>
            (iii)<strong>Australia Consumers Only.</strong>To begin an
            arbitration proceeding, you must send a letter requesting
            arbitration and describing your claim to our registered agent,
            General Counsel, at Level 15, 222 Exhibition Street, Melbourne VIC
            3000 Australia. The arbitration will be conducted by the Australian
            Disputes Centre (“
                        <strong>ADC</strong>”) under then-current arbitration rules and
            pursuant to the terms of this Agreement. The ADC’s arbitration rules
            are available at:
            disputescentre.com.au/adc-rules-for-domestic-arbitration. Payment of
            all filing, administration, and arbitration fees will be governed by
            the ADC’s rules. If the arbitrator finds that you cannot afford to
            pay the ADC’s filing, administrative, hearing, and/or other fees and
            cannot obtain a waiver of fees from the ADC, OHMYFOOD will pay them
            for you. In addition, OHMYFOOD will reimburse all such ADC’s filing,
            administrative, hearing, and/or other fees for claims with an amount
            in controversy totaling less than AUD $10,000. If the ADC is not
            available to arbitrate, the parties will select an alternative
            arbitral forum. You may choose to have the arbitration conducted by
            telephone, video conference, based on written submissions, or in
            person in the country where you live or at another mutually agreed
            location.
                    </p>
                    <p className='terms-text'>
            (iv)<strong>New Zealand Consumers Only.</strong>This Arbitration
            Agreement is governed by the Arbitration Act 1996 and Schedule 2 of
            the Arbitration Act 1996 will not apply to any arbitration. Where
            you are a “consumer” for the purposes of the Arbitration Act 1996,
            this agreement to arbitrate is subject to a separate written
            agreement after the dispute has arisen in accordance with section 11
            of the Arbitration Act 1996.
                    </p>
                    <p className='terms-text'>
            (d)<strong>Arbitrator Powers.</strong>The arbitrator, and not any
            federal, state, provincial, or local court or agency, shall have
            exclusive authority to resolve any dispute relating to the
            interpretation, applicability, enforceability, or formation of this
            Arbitration Agreement including, but not limited to, any claim that
            all or any part of this Arbitration Agreement is void or voidable,
            to the extent permitted by applicable law except with respect to
            Section 14(f) below (Waiver of Class, Consolidated, and
            Representative Actions; Waiver of Public Injunctive Relief), the
            enforceability of which can only be determined by a court.
                    </p>
                    <p className='terms-text'>
            The arbitration will decide the rights and liabilities, if any, of
            you and OHMYFOOD. Except as expressly agreed to in Section 14(g) of
            this Agreement, the arbitration proceeding will not be consolidated
            with any other matters or joined with any other proceedings or
            parties. The arbitrator may issue orders (including subpoenas to
            third parties, to the extent permitted by law) allowing the parties
            to conduct discovery sufficient to allow each party to prepare that
            party&apos;s claims and/or defenses, taking into consideration that
            arbitration is designed to be a speedy and efficient method for
            resolving disputes. For example, the parties agree that the Apex
            Doctrine shall apply and therefore preclude depositions of either
            party’s current or former high-level officers absent a showing that
            the officer has unique, personal knowledge of discoverable
            information and less burdensome discovery methods have been
            exhausted. The arbitrator will have the authority to grant motions
            dispositive of all or part of any claim or dispute. The arbitrator
            will have the authority to award, on an individual basis, monetary
            damages and to grant any non-monetary remedy or relief available to
            an individual under applicable law, the arbitral forum’s rules, and
            this Agreement (including this Arbitration Agreement). The
            arbitrator will issue a written statement of decision describing the
            essential findings and conclusions on which any award (or decision
            not to render an award) is based, including the calculation of any
            damages awarded. The award shall be binding only among the parties
            and shall have no preclusive effect in any other arbitration or
            other proceeding involving a different party. The arbitrator shall
            follow the applicable law. The arbitrator has the same authority to
            award relief on an individual basis that a judge in a court of law
            would have. The arbitrator’s decision is final and binding on you
            and OHMYFOOD.
                    </p>
                    <p className='terms-text'>
            (e)<strong>Waiver of Jury Trial.</strong>TO THE EXTENT PERMITTED BY
            APPLICABLE LAW, YOU AND OHMYFOOD WAIVE ANY CONSTITUTIONAL AND
            STATUTORY RIGHTS TO SUE IN COURT AND RECEIVE A JUDGE OR JURY TRIAL.
            You and OHMYFOOD are instead electing to have all disputes resolved
            by binding arbitration, except as specified in Section 14(a) above.
            Binding arbitration is a dispute resolution process in which a
            neutral third party (the arbitrator) makes a final and binding
            decision resolving the dispute. There is no judge or jury in
            arbitration, and court review of an arbitration award is limited.
                    </p>
                    <p className='terms-text'>
            (f)
                        <strong>
              Waiver of Class, Consolidated, and Representative Actions; Waiver
              of Public Injunctive Relief (United States, Canada, and New
              Zealand Consumers Only).
                        </strong>
            THIS SECTION14(f) DOES NOT APPLY TO AUSTRALIA CONSUMERS. EXCEPT AS
            EXPRESSLY AGREED TO IN SECTION 14(g) OF THIS AGREEMENT AND TO THE
            EXTENT PERMITTED BY APPLICABLE LAW, YOU AND OHMYFOOD AGREE TO WAIVE
            ANY RIGHT TO RESOLVE CLAIMS WITHIN THE SCOPE OF THIS ARBITRATION
            AGREEMENT ON A CLASS, COLLECTIVE, OR REPRESENTATIVE BASIS. ALL
            CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT
            MUST BE ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS,
            COLLECTIVE, OR REPRESENTATIVE BASIS. CLAIMS OF MORE THAN ONE
            CUSTOMER OR USER CANNOT BE ARBITRATED OR LITIGATED JOINTLY OR
            CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR USER. In any case
            in which (1) the dispute is filed as a class, collective, or
            representative action and (2) a civil court of competent
            jurisdiction finds all or part of the Waiver of Class, Consolidated,
            and Representative Actions is unenforceable, the class, collective,
            or representative action must be litigated in a civil court of
            competent jurisdiction, but the portion of the Waiver of Class,
            Consolidated, and Representative Actions that is enforceable shall
            be enforced in arbitration. The portion of such dispute proceeding
            in court shall be stayed pending the conclusion of the arbitration.
            Notwithstanding any other provision in this Agreement, any claim
            that all or part of the waivers set forth in Section 14(f) is
            unenforceable, unconscionable, void, or voidable may be determined
            only by a court of competent jurisdiction and not by an arbitrator.
            This provision does not prevent you or OHMYFOOD from settling claims
            on a class, collective, or representative basis.
                    </p>
                    <p className='terms-text'>
            (g)<strong>Grouped Arbitrations.</strong>To the extent permitted by
            applicable law and notwithstanding any other provision of this
            Agreement, to increase efficiency of resolution, in the event 100 or
            more similar arbitration demands are presented to an arbitration
            provider selected in accordance with the rules described above
            within a 30-day period: (A) the parties shall cooperate to organize
            the arbitration demands into randomized groups of no more than 100
            demands (plus, to the extent there are fewer than 100 arbitration
            demands remaining after the assigning as described above, a final
            group consisting of the remaining demands); (B) claimants’ counsel
            shall organize and present the grouped demands to the arbitration
            provider in a format as directed by the arbitration provider; (C)
            the arbitration provider shall assess one set of filing and
            administrative fees per group and shall assign one arbitrator per
            group, pursuant to the applicable arbitration provider’s rules
            governing arbitrator assignment and subject to any applicable
            disclosure and disqualification procedures available under
            applicable law; (D) the arbitration provider shall set up one
            Arbitration Management Conference per group; (E) regardless of the
            grouping described above, the arbitrator shall resolve all
            arbitrations within a group on an individual basis; and (F) no final
            award from an arbitrator in any one arbitration shall have
            preclusive effect in any other arbitration. You agree to cooperate
            in good faith with OHMYFOOD and the arbitration provider to
            implement such a grouped approach to administration and fees.
            Notwithstanding any provision in the Agreement to the contrary,
            grouped arbitrations shall take place in person or, if the parties
            prefer, by video conference. The parties may also agree to conduct
            arbitration based on written submissions alone.
                    </p>
                    <p className='terms-text'>
            (h)<strong>Opt Out.</strong>OHMYFOOD’s updates to these Terms and
            Conditions do not provide a new opportunity to opt out of the
            Arbitration Agreement for customers or Users who had previously
            agreed to a version of OHMYFOOD’s or Caviar’s Terms and Conditions
            and did not validly opt out of arbitration. OHMYFOOD will continue
            to honor the valid opt outs of customers or Users who validly opted
            out of the Arbitration Agreement in a prior version of the Terms and
            Conditions. If you are a customer or User who creates a OHMYFOOD or
            Caviar account for the first time on or after the effective date of
            these Terms and Conditions, you may opt out of this Arbitration
            Agreement. If you do so, neither you nor OHMYFOOD can force the
            other to arbitrate as a result of this Agreement. To opt out, you
            must notify OHMYFOOD in writing no later than 30 days after first
            becoming subject to this Arbitration Agreement. Your notice must
            include your name and address, your OHMYFOOD username (if any), the
            email address you currently use to access your OHMYFOOD account (if
            you have one), and a CLEAR statement that you want to opt out of
            this Arbitration Agreement. You must send your opt-out notice to:
            opt-out@OHMYFOOD.com. If you opt out of this Arbitration Agreement,
            all other parts of this Agreement will continue to apply to you.
            Opting out of this Arbitration Agreement has no effect on any other
            arbitration agreements that you may have entered into with us or may
            enter into in the future with us.
                    </p>

                    <p className='terms-text'>
            (i)<strong>No Effect on Independent Contractor Agreement.</strong>
            NOTWITHSTANDING ANYTHING TO THE CONTRARY IN THIS AGREEMENT, NOTHING
            IN THIS AGREEMENT SHALL SUPERSEDE, AMEND, OR MODIFY THE TERMS OF ANY
            SEPARATE AGREEMENT(S) BETWEEN YOU AND OHMYFOOD RELATING TO YOUR WORK
            AS AN EMPLOYEE OR INDEPENDENT CONTRACTOR, INCLUDING WITHOUT
            LIMITATION, ANY INDEPENDENT CONTRACTOR AGREEMENT GOVERNING YOUR
            SERVICES AS A CONTRACTOR. FOR THE AVOIDANCE OF DOUBT, IF YOU ARE A
            CONTRACTOR, OPTING OUT OF THE ARBITRATION AGREEMENT SET FORTH IN
            SECTION 14 HAS NO EFFECT ON YOUR AGREEMENT TO ARBITRATE DISPUTES
            COVERED BY YOUR INDEPENDENT CONTRACTOR AGREEMENT WITH OHMYFOOD.
                    </p>

                    <p className='terms-text'>
            (j)<strong>Survival.</strong>This Arbitration Agreement will survive
            any termination of your relationship with OHMYFOOD.
                    </p>

                    <p className='terms-text'>
            (k)<strong>Modification.</strong>Notwithstanding any provision in
            the Agreement to the contrary, we agree that if OHMYFOOD makes any
            future material change to this Arbitration Agreement, it will not
            apply to any individual claim(s) that you had already provided
            notice of to OHMYFOOD.
                    </p>

                    <p className='terms-text'>
            (l)<strong>Entire Agreement; Severability.</strong>This Arbitration
            Agreement is the full and complete agreement relating to the formal
            resolution of disputes covered by this Arbitration Agreement. In the
            event any portion of this Arbitration Agreement is deemed
            unenforceable, the remainder of this Arbitration Agreement will be
            enforceable.
                    </p>
                </section>

                {/* Section 15 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>15. Third-Party Interactions</h2>
                    <p className='terms-text'>
            (a)
                        <strong>
              Third-Party Websites, Applications, and Advertisements.
                        </strong>
            The Services may contain links to third-party websites (“
                        <strong>Third-Party Websites</strong>
            ”), applications (“<strong>Third-Party Applications</strong>”), and
            advertisements (“<strong>Third-Party Advertisements</strong>”)
            (collectively, “
                        <strong>Third-Party Websites and Advertisements</strong>”). When you
            click or tap on a link to a Third-Party Website, Third-Party
            Application, or Third-Party Advertisement, OHMYFOOD will not warn
            you that you have left OHMYFOOD’s website or Services and will not
            warn you that you are subject to the terms and conditions (including
            privacy policies) of another website or destination. Such
            Third-Party Websites and Advertisements are not under the control of
            OHMYFOOD. OHMYFOOD is not responsible for any Third-Party Websites
            and Advertisements. OHMYFOOD provides links to these Third-Party
            Websites and Advertisements only as a convenience and does not
            review, approve, monitor, endorse, warrant, or make any
            representations with respect to such Third-Party Websites and
            Advertisements or their products or services. You use all links in
            Third-Party Websites and Advertisements at your own risk. You should
            review applicable terms and policies, including privacy and data
            gathering practices, of any Third-Party Websites or Third-Party
            Applications, and make whatever investigation you feel necessary or
            appropriate before proceeding with any transaction with any third
            party.
                    </p>

                    <p className='terms-text'>
            (b)<strong>App Stores.</strong>You acknowledge and agree that the
            availability of the Technology and the Services is dependent on the
            third party from which you received the application license, such as
            the Apple or Android app store (each, an “<strong>App Store</strong>
            ”). You acknowledge and agree that this Agreement is between you and
            OHMYFOOD and not with the App Store. OHMYFOOD, not the App Store, is
            solely responsible for the Technology and the Services, including
            the mobile application(s), the content thereof, maintenance, support
            services, and warranty therefor, and addressing any claims relating
            thereto (for example, product liability, legal compliance, or
            intellectual property infringement). In order to use the Technology
            and the Services, you must have access to a wireless network, and
            you agree to pay all fees associated with such access. You also
            agree to pay all fees (if any) charged by the App Store in
            connection with the Technology or the Services. You agree to comply
            with, and your license to use the Technology and the Services is
            conditioned upon your compliance with, all applicable third-party
            terms or agreements (for example, the App Store’s terms and
            policies) when using the Technology or the Services. You represent
            and warrant that you are not located in a country that is subject to
            a United States Government embargo or similar laws of other
            countries where applicable, or that has been designated by the
            United States or Canadian Government as a “terrorist supporting”
            country, and you represent and warrant that you are not listed on
            any United States or Canadian Government list of prohibited or
            restricted parties. You acknowledge and agree that each App Store
            (and its affiliates) is an intended third-party beneficiary of this
            Agreement and has the right to enforce the terms and conditions of
            this Agreement.
                    </p>
                </section>

                {/* Section 16 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>
            16. Transactions Involving Alcohol and Other Age-Restricted Products
                    </h2>
                    <p className='terms-text'>
            You may have the option to request delivery or pickup of alcohol
            products in some locations and from certain Merchants. You agree
            that you will only order alcohol products if you, the intended
            recipient, and anyone who may consume the alcohol products are of
            legal age to purchase and consume alcohol products in the relevant
            jurisdiction. You also agree that, upon delivery or pickup of
            alcohol products, the recipient of any alcohol products will provide
            valid government-issued identification proving the requisite legal
            age and that the recipient will not be intoxicated when receiving
            such products. If you order alcohol products, you understand and
            acknowledge that the order will only be delivered if the Merchant
            accepts your order. The person delivering alcohol may be legally
            obligated to refuse delivery pursuant to applicable federal, state,
            provincial, or local laws, rules, or regulations, including if the
            recipient is not of legal age, is visibly intoxicated, or is not
            physically present to accept the delivery, and will be prompted to
            refuse delivery if the recipient cannot provide a valid
            government-issued identification proving requisite legal age, is
            visibly intoxicated, or is not physically present to accept the
            delivery. If the delivery of alcohol products cannot be completed
            for one or more of these reasons, you agree and acknowledge that
            your purchase is non-refundable and you or the intended recipient
            may not receive any part of the applicable order, including any
            non-alcohol items that you may have purchased with your alcohol
            products, and you may also be subject to a non-refundable
            Undeliverable Item Fee. Alcohol is not available in all locations
            that are served by the OHMYFOOD platform. Alcohol may be removed
            from the platform for specific Users at OHMYFOOD’s sole discretion.
                    </p>
                    <p className='terms-text'>
            You may also have the option to request delivery or pickup of other
            age-restricted items from certain Merchants, such as certain
            over-the-counter medication or other products subject to applicable
            federal, state, provincial, or local laws, rules, or regulations or
            Merchant or OHMYFOOD policies requiring age verification. You agree
            that you will only order age-restricted items if you, the intended
            recipient, or anyone who may consume such products are of legal age
            to purchase the items. You also agree that, upon delivery or pickup
            of age-restricted items, the recipient will provide valid
            government-issued identification proving the requisite legal age for
            such age-restricted items. The person delivering age-restricted
            items will refuse delivery pursuant to applicable federal, state,
            provincial, or local laws, rules, or regulations, including if the
            recipient cannot provide a valid government-issued identification
            proving requisite legal age or is not physically present to accept
            the delivery. If the delivery of age-restricted items cannot be
            completed for one or more of these reasons, you agree and
            acknowledge that your purchase is non-refundable and you may not
            receive any part of your order, including items that are not
            age-restricted that you may have purchased with your age-restricted
            items, and you may also be subject to a non-refundable Undeliverable
            Item Fee.
                    </p>
                </section>

                {/* Section 17 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>17. Indemnification</h2>
                    <p className='terms-text'>
            To the extent permitted by law, you agree to indemnify and hold
            harmless OHMYFOOD and its officers, directors, employees, agents,
            and affiliates (each, an “<strong>Indemnified Party</strong>”) from
            and against any losses, claims, actions, costs, damages, penalties,
            fines, and expenses, including without limitation, legal and/or
            attorneys’ fees and expenses, that may be incurred by an Indemnified
            Party arising out of, relating to, or resulting from (a) your User
            Content; (b) your misuse of the Technology or Services; (c) your
            breach of this Agreement or any representation, warranty, condition,
            or covenant in this Agreement; or (d) your violation of any
            applicable laws, rules, or regulations through or related to the use
            of the Technology or Services. In the event of any claim,
            allegation, suit, or proceeding alleging any matter potentially
            covered by the agreements in this Section 17, you agree to pay for
            the defense of the Indemnified Party, including reasonable costs and
            legal and/or attorneys’ fees incurred by the Indemnified Party.
            OHMYFOOD reserves the right, at its own cost, to assume the
            exclusive defense and control of any matter otherwise subject to
            indemnification by you, in which event you will fully cooperate with
            OHMYFOOD in asserting any available defenses. This Section 17 does
            not require you to indemnify any Indemnified Party for any
            unconscionable commercial practice by such party, or for such
            party’s negligence, fraud, deception, false promise,
            misrepresentation or concealment, suppression, or omission of any
            material fact in connection with the Technology or Services. You
            agree that the provisions of this Section 17 will survive any
            termination of your account, this Agreement, or your access to the
            Technology and/or Services.
                    </p>
                </section>

                {/* Section 18 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>18. Disclaimer of Warranties</h2>
                    <p className='terms-text'>
            UNITED STATES FEDERAL LAW AND SOME STATES, PROVINCES, AND OTHER
            JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN
            IMPLIED WARRANTIES, SO SOME OF THE EXCLUSIONS IN THIS SECTION 18 MAY
            NOT APPLY TO YOU. SECTION 18 APPLIES TO THE FULLEST EXTENT PERMITTED
            BY APPLICABLE LAW.
                    </p>
                    <p className='terms-text'>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE TECHNOLOGY
            AND SERVICES IS ENTIRELY AT YOUR OWN RISK. CHANGES ARE PERIODICALLY
            MADE TO THE TECHNOLOGY AND SERVICES AND MAY BE MADE AT ANY TIME
            WITHOUT NOTICE TO YOU. OHMYFOOD WILL USE REASONABLE ENDEAVORS TO
            ENSURE THE TECHNOLOGY AND SERVICES ARE AVAILABLE AS MUCH OF THE TIME
            AS POSSIBLE, BUT DOES NOT GUARANTEE THEY WILL BE AVAILABLE ALL OF
            THE TIME. THE TECHNOLOGY AND SERVICES ARE PROVIDED ON AN “AS IS”
            BASIS WITHOUT GUARANTEES, WARRANTIES, OR CONDITIONS OF ANY KIND,
            EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
            GUARANTEES, WARRANTIES, OR CONDITIONS OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR OR GENERAL PURPOSE, AND NON-INFRINGEMENT. OHMYFOOD
            MAKES NO WARRANTIES, CONDITIONS, OR REPRESENTATIONS ABOUT THE
            ACCURACY, RELIABILITY, COMPLETENESS, OR TIMELINESS OF THE CONTENT
            MADE AVAILABLE THROUGH THE TECHNOLOGY OR SERVICES, OR THE SERVICES,
            TECHNOLOGY, TEXT, GRAPHICS, OR LINKS.
                    </p>
                    <p className='terms-text'>
            OHMYFOOD DOES NOT WARRANT THAT THE TECHNOLOGY OR SERVICES WILL
            OPERATE ERROR-FREE OR THAT THE TECHNOLOGY OR SERVICES ARE FREE OF
            COMPUTER VIRUSES AND OTHER HARMFUL MALWARE. IF YOUR USE OF THE
            TECHNOLOGY OR SERVICES RESULTS IN THE NEED FOR SERVICING OR
            REPLACING EQUIPMENT OR DATA, OHMYFOOD SHALL NOT BE RESPONSIBLE FOR
            THOSE ECONOMIC COSTS.
                    </p>
                    <p className='terms-text'>
                        <strong>AUSTRALIA AND NEW ZEALAND ORDERS:</strong> FOR AUSTRALIA AND
            NEW ZEALAND ORDERS, NOTHING IN THIS AGREEMENT EXCLUDES, RESTRICTS,
            OR MODIFIES ANY GUARANTEE, TERM, CONDITION, WARRANTY, OR ANY RIGHT
            OR REMEDY IMPLIED OR IMPOSED BY ANY LEGISLATION WHICH CANNOT
            LAWFULLY BE EXCLUDED OR LIMITED, INCLUDING: (a) FOR AUSTRALIA
            ORDERS, THE AUSTRALIAN CONSUMER LAW, WHICH CONTAINS GUARANTEES THAT
            PROTECT THE PURCHASERS OF GOODS AND SERVICES IN CERTAIN
            CIRCUMSTANCES; and (b) FOR NEW ZEALAND ORDERS, THE CONSUMER
            GUARANTEES ACT 1993 AND THE FAIR TRADING ACT 1986, WHICH CONTAIN
            GUARANTEES THAT PROTECT THE PURCHASERS OF GOODS AND SERVICES IN
            CERTAIN CIRCUMSTANCES (EACH, A “
                        <strong>NON-EXCLUDABLE PROVISION</strong>”).
                    </p>
                </section>

                {/* Section 19 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>19. Internet Delays</h2>
                    <p className='terms-text'>
            The Technology and Services may be subject to limitations, delays,
            and other problems inherent in the use of the Internet and
            electronic communications. Except as otherwise required by
            applicable law and subject to the Non-Excludable Provisions,
            OHMYFOOD is not responsible for any delays, delivery failures,
            damage, loss, injury, or other economic damage resulting from such
            problems.
                    </p>
                </section>

                {/* Section 20 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>
            20. Breach and Limitation of Liability
                    </h2>
                    <p className='terms-text'>
            This Section 20 applies to the fullest extent permitted by
            applicable law, and some provisions in this Section 20 may not apply
            in certain jurisdictions.
                    </p>
                    <p className='terms-text'>
            (a)<strong>United States and Canada Consumers.</strong>This Section
            20(a) applies to United States and Canada Consumers. You understand
            and agree that a key element of the Services and this Agreement is
            your and our mutual desire to keep the Services simple and efficient
            and to provide the Technology and Services at low cost. You
            understand and agree to the limitations on remedies and liabilities
            set forth in this Section 20(a) to keep the Technology and Services
            simple and efficient, and costs low, for all Users.
                    </p>
                    <p className='terms-text'>
                        <strong>Cap on Liability.</strong>TO THE FULLEST EXTENT PERMITTED BY
            APPLICABLE LAW, OHMYFOOD’S AGGREGATE LIABILITY SHALL NOT EXCEED THE
            GREATER OF AMOUNTS ACTUALLY PAID BY AND/OR DUE FROM YOU TO OHMYFOOD
            IN THE SIX (6) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT GIVING
            RISE TO SUCH CLAIM. THIS CAP ON LIABILITY SHALL APPLY FULLY TO
            RESIDENTS OF THE STATE OF NEW JERSEY IN THE UNITED STATES.
                    </p>
                    <p className='terms-text'>
                        <strong>Disclaimer of Certain Damages.</strong>TO THE FULLEST EXTENT
            PERMITTED BY APPLICABLE LAW, OHMYFOOD SHALL NOT BE LIABLE TO YOU OR
            ANYONE ELSE FOR ANY INDIRECT, PUNITIVE, SPECIAL, EXEMPLARY,
            INCIDENTAL, CONSEQUENTIAL, OR OTHER DAMAGES OF ANY TYPE OR KIND
            (INCLUDING PERSONAL INJURY, LOST PROFITS, PAIN AND SUFFERING,
            EMOTIONAL DISTRESS, AND LOSS OF DATA, REVENUE, USE, AND ECONOMIC
            ADVANTAGE).
                        <strong>
              THE FOREGOING DISCLAIMER OF PUNITIVE AND EXEMPLARY DAMAGES, AND
              THE ENTIRE DISCLAIMER OF DAMAGES FOR PERSONAL INJURY OR PROPERTY
              DAMAGE, OR FOR ANY INJURY CAUSED BY OHMYFOOD’S FRAUD OR FRAUDULENT
              MISREPRESENTATION, SHALL NOT APPLY TO USERS WHO RESIDE IN THE
              STATE OF NEW JERSEY IN THE UNITED STATES OR THE PROVINCE OF QUÉBEC
              IN CANADA.
                        </strong>
                    </p>

                    <p className='terms-text'>
            (b) <strong>Australia and New Zealand Consumers</strong>
                    </p>
                    <p className='terms-text'>
            (i)<strong>Australia Consumers.</strong>THIS SECTION 20(b)(i)
            APPLIES TO AUSTRALIA CONSUMERS. TO THE FULLEST EXTENT PERMITTED BY
            APPLICABLE LAW, THE LIABILITY OF OHMYFOOD FOR BREACH OF ANY
            NON-EXCLUDABLE PROVISION IS LIMITED TO ONE OR MORE OF THE FOLLOWING
            AT OHMYFOOD’S OPTION: (A) IN THE CASE OF GOODS, THE REPLACEMENT OF
            THE GOODS OR THE SUPPLY OF EQUIVALENT GOODS, THE REPAIR OF THE
            GOODS, THE PAYMENT OF THE COST OF REPLACING THE GOODS OR OF
            ACQUIRING EQUIVALENT GOODS, OR THE PAYMENT OF THE COST OF HAVING THE
            GOODS REPAIRED; OR (B) IN THE CASE OF SERVICES, THE SUPPLYING OF THE
            SERVICES AGAIN OR THE PAYMENT OF THE COST OF HAVING THE SERVICES
            SUPPLIED AGAIN.
                    </p>
                    <p className='terms-text'>
            (ii)<strong>New Zealand Consumers.</strong>THIS SECTION 20(b)(ii)
            APPLIES TO NEW ZEALAND CONSUMERS.
                    </p>
                    <p className='terms-text'>
            (A) OUR SERVICES COME WITH CONSUMER GUARANTEES UNDER THE CONSUMER
            GUARANTEES ACT 1993. YOU ARE ENTITLED TO A REPLACEMENT OR REFUND FOR
            A FAILURE OF SUBSTANTIAL CHARACTER AND YOU MAY ALSO BE ENTITLED TO
            COMPENSATION FOR ANY OTHER REASONABLY FORESEEABLE LOSS OR DAMAGE. IF
            THE FAILURE IS NOT OF SUBSTANTIAL CHARACTER, YOU MAY BE ENTITLED TO:
            (1) IN THE CASE OF GOODS, THE REPLACEMENT OF THE GOODS, THE REPAIR
            OF THE GOODS, OR A REFUND IF THE GOODS CANNOT BE REASONABLY REPAIRED
            OR REPLACED; OR (2) IN THE CASE OF SERVICES, THE SUPPLYING OF THE
            SERVICES AGAIN OR A REFUND. THERE MAY BE OTHER REMEDIES AVAILABLE
            UNDER THE CONSUMER GUARANTEES ACT 1993, DEPENDING ON THE
            CIRCUMSTANCES. OHMYFOOD’S LIABILITY IN RELATION TO ITS PROVISION OF
            THE SERVICES OR GOODS IS LIMITED TO THE REMEDIES THAT ARE PROVIDED
            PURSUANT TO THE NON-EXCLUDABLE PROVISIONS AND THE GUARANTEES SET OUT
            IN SECTION 20(b) OF THIS AGREEMENT.
                    </p>
                    <p className='terms-text'>
            (B) You agree and acknowledge that if you are in trade and acquire,
            or hold yourself out as acquiring, the goods or services (as
            applicable) for business purposes in terms of section 43(2) of the
            Consumer Guarantees Act 1993, then the Consumer Guarantees Act 1993
            does not apply and that its non-application is fair and reasonable.
                    </p>
                    <p className='terms-text'>
            (C) To the extent permitted by law, where the goods or services (as
            applicable) are supplied in trade within the meaning of the Fair
            Trading Act 1986, the parties agree to contract out of sections 9,
            12A, 13, and 14(1) of that Act.
                    </p>
                    <p className='terms-text'>
            (D) You agree and acknowledge that part 3 of the Contract and
            Commercial Law Act 2017 will not apply.
                    </p>
                    <p className='terms-text'>
            (E) You agree and acknowledge that you do not rely on the
            representations or other conduct by OHMYFOOD, including any of its
            officers, employees, and sales representatives, whether during
            negotiations prior to these Terms being entered into or at any time
            subsequent to the entry into the Agreement.
                    </p>
                    <p className='terms-text'>
            (iii)
                        <strong>
              Cap on Liability (Australia and New Zealand Consumers).
                        </strong>
            THIS SECTION 20(b)(iii) APPLIES TO AUSTRALIA AND NEW ZEALAND
            CONSUMERS. SUBJECT TO THE NON-EXCLUDABLE PROVISIONS AND TO THE
            FULLEST EXTENT PERMITTED BY APPLICABLE LAW,OHMYFOOD’S AGGREGATE
            LIABILITY UNDER ALL THEORIES OF LAW AND EQUITY (INCLUDING
            NEGLIGENCE) SHALL NOT EXCEED THE GREATER OF (A) AMOUNTS ACTUALLY
            PAID BY AND/OR DUE FROM YOU TO OHMYFOOD IN THE SIX (6) MONTH PERIOD
            IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO SUCH CLAIM, AND (B)
            THE REMEDY OR PENALTY IMPOSED BY THE STATUTE UNDER WHICH SUCH CLAIM
            ARISES. THE FOREGOING CAP ON LIABILITY SHALL NOT APPLY TO LIABILITY
            OF OHMYFOOD FOR (Y) DEATH OR PERSONAL INJURY CAUSED BY OHMYFOOD’S
            NEGLIGENCE OR WILLFUL MISCONDUCT, OR (Z) ANY INJURY CAUSED BY
            OHMYFOOD’S FRAUD OR FRAUDULENT MISREPRESENTATION.
                    </p>
                    <p className='terms-text'>
            (iv)
                        <strong>
              Disclaimer of Certain Damages (Australia and New Zealand
              Consumers).
                        </strong>
            THIS SECTION 20(b)(iv) APPLIES TO AUSTRALIA AND NEW ZEALAND
            CONSUMERS. SUBJECT TO THE NON-EXCLUDABLE PROVISIONS AND TO THE
            FULLEST EXTENT PERMITTED BY APPLICABLE LAW, OHMYFOOD SHALL NOT BE
            LIABLE TO ANYONE FOR ANY INDIRECT, PUNITIVE, SPECIAL, EXEMPLARY,
            INCIDENTAL, CONSEQUENTIAL, OR OTHER DAMAGES OF ANY TYPE OR KIND
            (INCLUDING PERSONAL INJURY OR LOSS OR CORRUPTION OF DATA, GOODWILL,
            REVENUE, PROFITS, ANTICIPATED SAVINGS, USE, OR OTHER ECONOMIC
            ADVANTAGE), UNDER ANY THEORIES OF LAW AND EQUITY (INCLUDING
            NEGLIGENCE), AND WHETHER OR NOT SUCH LOSS OR DAMAGE WAS FORESEEABLE
            AND EVEN IF ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
            EXCEPT AS EXPRESSLY PROVIDED IN SECTIONS 6 AND 12, TO THE FULLEST
            EXTENT PERMITTED BY APPLICABLE LAW, OHMYFOOD SHALL NOT BE LIABLE FOR
            ANY LOSS, DAMAGE, OR INJURY WHICH MAY BE INCURRED BY YOU, INCLUDING
            BUT NOT LIMITED TO LOSS, DAMAGE, OR INJURY ARISING OUT OF, OR IN ANY
            WAY CONNECTED WITH, OUR WEBSITES, THE TECHNOLOGY, OR THE SERVICES,
            INCLUDING BUT NOT LIMITED TO THE USE OR INABILITY TO USE OUR
            WEBSITES, THE TECHNOLOGY, OR THE SERVICES, ANY RELIANCE PLACED BY
            YOU ON THE COMPLETENESS, ACCURACY, OR EXISTENCE OF ANY ADVERTISING,
            OR AS A RESULT OF ANY RELATIONSHIP OR TRANSACTION BETWEEN YOU AND
            ANY MERCHANT, CONTRACTOR, ADVERTISER, OR SPONSOR WHOSE ADVERTISING
            APPEARS ON OUR WEBSITES OR THE TECHNOLOGY, OR IS REFERRED BY THE
            TECHNOLOGY OR SERVICES, EVEN IF OHMYFOOD AND/OR ITS LICENSORS HAVE
            BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                    </p>
                </section>

                {/* Section 21 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>21. Exclusive Venue</h2>
                    <p className='terms-text'>
            (a)<strong>United States Consumers.</strong>If you are a United
            States Consumer, to the extent the parties are permitted under this
            Agreement to initiate litigation in a court, both you and OHMYFOOD
            agree that all claims and disputes arising out of or relating in any
            way to the subject matter of the Agreement, to your access or use of
            the Services as a User of the Services, to any advertising or
            marketing communications regarding OHMYFOOD or the Services, to any
            products or services sold or distributed through the Services that
            you received as a User of our Services, or to any aspect of your
            relationship or transactions with OHMYFOOD as a User of our Services
            (this includes, without limitation, any contract claim, tort claim,
            statutory claim, or claim for unfair competition), will be litigated
            exclusively in the state or federal courts located in San Francisco
            County if you are a California citizen or resident, and in the
            United States District Court for the District in which you reside if
            you are not a California citizen or resident.
                    </p>
                    <p className='terms-text'>
            (b)<strong>Canada Consumers.</strong>If you are a Canada Consumer,
            except where prohibited by applicable law (which includes the
            Province of Québec), to the extent the parties are permitted under
            this Agreement to initiate litigation in a court, both you and
            OHMYFOOD agree that all claims and disputes arising out of or
            relating to the Agreement will be litigated exclusively in the
            Superior Court of Justice or Federal Court of Canada residing in
            Toronto, Ontario.
                    </p>
                    <h3 className='terms-subheading'>
            (c) Australia and New Zealand Consumers
                    </h3>
                    <p className='terms-text'>
            (c)<strong>Australia and New Zealand Consumers.</strong>If you are
            an Australia or New Zealand Consumer, to the extent the parties are
            permitted under this Agreement to initiate litigation in a court,
            both you and OHMYFOOD irrevocably agree that all claims and disputes
            arising out of or relating to the Agreement will be litigated
            non-exclusively in: (i) for Australia Consumers, the state or
            federal courts located in the State of Victoria, Australia and the
            Commonwealth of Australia; and (ii) for New Zealand Consumers, the
            courts located in New Zealand.
                    </p>
                </section>

                {/* Section 22 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>22. Termination</h2>
                    <p className='terms-text'>
            If you violate this Agreement, OHMYFOOD may respond based on a
            number of factors including, but not limited to, the egregiousness
            of your actions and whether a pattern of harmful behavior exists.
                    </p>
                    <p className='terms-text'>
            In addition, at its sole discretion, OHMYFOOD may modify or
            discontinue the Technology or Services, or may modify, suspend, or
            terminate your access to the Technology or the Services, for any
            reason, with or without notice to you and without liability to you
            or any third party. Where required by law, which may include in the
            Province ofQuébec, we will provide you with written notice of the
            suspension or termination of your access to the Technology or the
            Services, including of the reasons which led us to take such action.
            In addition to suspending or terminating your access to the
            Technology or the Services, OHMYFOOD reserves the right to take
            appropriate legal action, including without limitation, pursuing
            civil, criminal, or injunctive redress. Even after your right to use
            the Technology or the Services is terminated, this Agreement will
            remain enforceable against you. All provisions which by their nature
            should survive to give effect to those provisions shall survive the
            termination of this Agreement.
                    </p>
                </section>

                {/* Section 23 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>
            23. Procedure for Making Claims of Copyright Infringement
                    </h2>
                    <p className='terms-text'>
            It is OHMYFOOD’s policy to terminate membership privileges of any
            User who repeatedly infringes copyright upon prompt notification to
            OHMYFOOD by the copyright owner or the copyright owner’s legal
            agent. Without limiting the foregoing, if you believe that your work
            has been copied and posted on the Services in a way that constitutes
            copyright infringement, please provide our Copyright Agent with the
            following information: (a) an electronic or physical signature of
            the person authorized to act on behalf of the owner of the copyright
            interest; (b) a description of the copyrighted work that you claim
            has been infringed; (c) a description of the specific location on
            the Services of the material that you claim is infringing, including
            enough information to allow OHMYFOOD to locate the material; (d)
            your address, telephone number, and email address; (e) a written
            statement by you that you have a good faith belief that the disputed
            use is not authorized by the copyright owner, its agent, or the law;
            and (f) a statement by you, made under penalty of perjury, that the
            above information in your notice is accurate and that you are the
            copyright owner or authorized to act on the copyright owner’s
            behalf. This notice of a copyright infringement claim should be sent
            to OHMYFOOD’s Copyright Agent at the address set forth below, based
            on the country in which the copyright owner primarily resides or was
            formed:
                    </p>
                    <ul>
                        <li>
                            <strong>United States:</strong>General Counsel, OHMYFOOD, Inc.,
              303 2nd St., Suite 800 South, San Francisco, CA 94107
                        </li>
                        <li>
                            <strong>Canada:</strong>General Counsel, OHMYFOOD Technologies
              Canada, Inc., 1066 West Hastings St., Suite 2000, Vancouver, BC
              V6E 3X2, Canada
                        </li>
                        <li>
                            <strong>Australia:</strong>General Counsel, OHMYFOOD Technologies
              Australia Pty Ltd, Level 15, 222 Exhibition St., Melbourne, VIC
              3000, Australia
                        </li>
                        <li>
                            <strong>New Zealand:</strong>General Counsel, OHMYFOOD
              Technologies New Zealand, Quigg Partners, Level 7, 36 Brandon St.,
              Wellington, 6011, New Zealand
                        </li>
                    </ul>
                </section>

                {/* Section 24 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>
            24. Consumer Marketing Text Messages (United States Consumers Only)
                    </h2>
                    <p className='terms-text'>
            This Section 24 only applies to United States Consumers who request,
            agree, sign up, or otherwise consent to receive consumer marketing
            text messages (“<strong>Opt In</strong>”).
                    </p>
                    <p className='terms-text'>
            You authorize us to send consumer marketing text messages, including
            text messages sent via an automatic telephone dialing system, to the
            phone number associated with your Opt In. Consumer marketing text
            messages include, by way of example, messages that contain
            promotional offers or discounts, messages related to goods and
            services offered by OHMYFOOD, or messages informing you that you
            still have items in your shopping cart. You do not have to Opt In as
            a condition of purchase or signing up for, accessing, using, or
            continuing to use the OHMYFOOD platform. You confirm that you are
            the subscriber to the relevant phone number or that you are the
            customary user of that number and that you are authorized to Opt In.
            If you change or deactivate your phone number, you agree to update
            your OHMYFOOD account to help prevent us from inadvertently
            communicating with anyone who acquires your prior phone number.
                    </p>
                    <p className='terms-text'>
            To stop or unsubscribe from receiving consumer marketing text
            messages, either reply to such a message with “STOP” or text “STOP”
            to 63758, and the phone number associated with your Opt In will be
            unsubscribed from consumer marketing text messages. You may receive
            a text message to confirm that you have been unsubscribed. If you
            are experiencing issues with consumer marketing text messages,
            either reply to such a message with “HELP” or text “HELP” to 63758.
            For customer support, call 855-431-0459 or visit our Customer
            Support page.
                    </p>
                    <p className='terms-text'>
            Message and data rates may apply. Message frequency may vary. We may
            stop sending consumer marketing text messages to you at any time
            with or without notice. See our Privacy Policy for how we handle
            your information. Carriers are not liable for delayed or undelivered
            messages.
                    </p>
                </section>

                {/* Section 25 */}
                <section className='terms-section'>
                    <h2 className='terms-heading'>25. General</h2>
                    <p className='terms-text'>
            (a)<strong>No Joint Venture or Partnership.</strong>No joint
            venture, partnership, employment, or agency relationship exists
            between you, OHMYFOOD, or any third-party provider as a result of
            this Agreement or use of the Technology or Services.
                    </p>
                    <p className='terms-text'>
            (b)<strong>Choice of Law.</strong>Without giving effect to any
            principles that provide for the application of the law of any other
            jurisdiction, this Agreement is governed by the laws of: (i) for
            United States Orders, the State of Delaware consistent with the
            Federal Arbitration Act; (ii) for Canada Orders, and except where
            prohibited by applicable law (which includes the Province of
            Québec), the Province of Ontario and the laws of Canada applicable
            therein; (iii) for Australia Orders, the State of Victoria,
            Australia; and (iv) for New Zealand Orders, New Zealand.
                    </p>
                    <p className='terms-text'>
            (c)<strong>Severability.</strong>Except as otherwise provided in
            this Agreement, if any provision of this Agreement is found to be
            invalid or unenforceable under applicable law, the invalidity or
            unenforceability of such provision shall not affect the validity or
            enforceability of the remaining provisions of this Agreement, which
            shall remain in full force and effect.
                    </p>
                    <p className='terms-text'>
            (d)<strong>Consumer Complaints.</strong>If you have a complaint
            about the Services, please visit our Customer Support page. For
            United States Consumers who are residents of the State of
            California, and in accordance with California Civil Code § 1789.3,
            you may also contact the Complaint Assistance Unit of the Division
            of Consumer Services of the California Department of Consumer
            Affairs in writing at 1625 North Market Blvd., Suite N 112,
            Sacramento, CA 95834 or by telephone at (800) 952-5210.
                    </p>
                    <p className='terms-text'>
            (e)
                        <strong>
              Accessing and Downloading the Application from the Apple App
              Store.
                        </strong>
            The following applies to any Technology accessed through or
            downloaded from the Apple App Store (an “
                        <strong>App Store Sourced Application</strong>”):
                    </p>
                    <p className='terms-text'>
            (i) You acknowledge and agree that (A) the Agreement is concluded
            between you and OHMYFOOD only, and not Apple; and (B) OHMYFOOD, not
            Apple, is solely responsible for the App Store Sourced Application
            and content thereof. Your use of the App Store Sourced Application
            must comply with the App Store Terms of Service.
                    </p>
                    <p className='terms-text'>
            (ii) You acknowledge that Apple has no obligation whatsoever to
            furnish any maintenance and support services with respect to the App
            Store Sourced Application.
                    </p>
                    <p className='terms-text'>
            (iii) In the event of any failure of the App Store Sourced
            Application to conform to any applicable warranty, you may notify
            Apple, and Apple will refund the purchase price, if any, for the App
            Store Sourced Application to you and to the fullest extent permitted
            by applicable law, Apple will have no other warranty obligation
            whatsoever with respect to the App Store Sourced Application. As
            between OHMYFOOD and Apple, any other claims, losses, liabilities,
            damages, costs, or expenses attributable to any failure to conform
            to any warranty or condition will be the sole responsibility of
            OHMYFOOD.
                    </p>
                    <p className='terms-text'>
            (iv) You and OHMYFOOD acknowledge that, as between OHMYFOOD and
            Apple, Apple is not responsible for addressing any claims you have
            or any claims of any third party relating to the App Store Sourced
            Application or your possession and use of the App Store Sourced
            Application, including, but not limited to: (A) product liability
            claims; (B) any claim that the App Store Sourced Application fails
            to conform to any applicable legal or regulatory requirement; and
            (C) claims arising under consumer protection or similar legislation.
                    </p>
                    <p className='terms-text'>
            (v) You and OHMYFOOD acknowledge that, in the event of any
            third-party claim that the App Store Sourced Application or your
            possession and use of that App Store Sourced Application infringes
            that third party’s intellectual property rights, as between OHMYFOOD
            and Apple, OHMYFOOD, not Apple, will be solely responsible for the
            investigation, defense, settlement, and discharge of any such
            intellectual property infringement claim to the extent required by
            this Agreement.
                    </p>
                    <p className='terms-text'>
            (vi) You and OHMYFOOD acknowledge and agree that Apple, and Apple’s
            subsidiaries, are third-party beneficiaries of this Agreement as
            related to your license of the App Store Sourced Application, and
            that, upon your acceptance of this Agreement, Apple will have the
            right (and will be deemed to have accepted the right) to enforce
            this Agreement as related to your license of the App Store Sourced
            Application against you as a third-party beneficiary thereof.
                    </p>
                    <p className='terms-text'>
            (vii) Without limiting any other terms of this Agreement, you must
            comply with all applicable third-party terms of agreement when using
            the App Store Sourced Application.
                    </p>
                    <p className='terms-text'>
            (f)<strong>Notice.</strong>Where OHMYFOOD requires that you provide
            an email address, you are responsible for providing OHMYFOOD with
            your most current email address. In the event that the last email
            address you provided to OHMYFOOD is not valid, or for any reason is
            not capable of delivering to you any notices required or permitted
            by this Agreement, OHMYFOOD’s dispatch of the email containing such
            notice will nonetheless constitute effective notice. You agree that
            all agreements, notices, disclosures, payment or renewal
            notifications, and other communications that OHMYFOOD provides to
            you electronically (such as through email or posting through the
            Services, including in your OHMYFOOD account) satisfy any legal
            requirement that such communications be in writing or be delivered
            in a particular manner. You agree that you have the ability to store
            such electronic communications such that they remain accessible to
            you in an unchanged form. You may give notice to OHMYFOOD by
            visiting our Customer Support page and initiating a chat with us.
            Such notice shall be deemed given on the next business day after
            such notice is actually received by OHMYFOOD.
                    </p>
                    <p className='terms-text'>
            (g)<strong>Transfer and Assignment.</strong>This Agreement, and any
            rights and licenses granted hereunder, may not be transferred or
            assigned by you, but may be assigned by OHMYFOOD without
            restriction. Any attempted transfer or assignment in violation
            hereof shall be null and void. This Agreement binds and inures to
            the benefit of each party and the party’s successors and permitted
            assigns.
                    </p>
                    <p className='terms-text'>
            (h)<strong>Currency.</strong>Unless otherwise indicated, all prices
            and other amounts displayed through the Services are in the currency
            of the jurisdiction where delivery or pickup occurs.
                    </p>
                    <p className='terms-text'>
            (i)<strong>Use Only Where Legally Allowed.</strong>You shall not
            access or use any portion of the Services if you are not legally
            allowed to do so where you are located.
                    </p>
                    <p className='terms-text'>
            (j)<strong>Subcontracting.</strong>OHMYFOOD may subcontract any of
            its obligations under this Agreement without your prior written
            consent.
                    </p>
                    <p className='terms-text'>
            (k)<strong>Variation of Websites or Technology.</strong>We may from
            time to time vary, modify, or discontinue, temporarily or
            permanently, any or all of our websites or the Technology.
                    </p>
                    <p className='terms-text'>
            (l)<strong>Language Versions.</strong>You acknowledge and agree that
            (i) the official language of these Terms is English and French for
            Canada Consumers who reside in the Province of Québec and English
            for all other consumers, (ii) any discrepancy or conflict between
            the official language version and any other language version will be
            resolved with reference to and by interpreting the official language
            version, and (iii) any other language version that we may make
            available is being provided only as a courtesy.
                    </p>
                    <p className='terms-text'>
            (m)<strong>Entire Agreement.</strong>This Agreement is the final,
            complete, and exclusive agreement of the parties with respect to the
            subject matter hereof and supersedes and merges all prior
            discussions between the parties with respect to such subject matter.
            However, nothing in this Agreement shall supersede, amend, or modify
            the terms of any separate agreement(s) between you and OHMYFOOD
            relating to your work as an employee or independent contractor,
            including, without limitation, any Independent Contractor Agreement
            governing your efforts as a Contractor.
                    </p>
                </section>

                <section className='terms-section'>
                    <h2 className='terms-heading'>26. Contact Information </h2>
                    <p className='terms-text'>
            OHMYFOOD welcomes your questions or comments regarding this
            Agreement. Please find our contact information below:
                    </p>
                    <p className='terms-text'>
                        <strong>United States:</strong>
                    </p>
                    <p className='terms-text'>OHMYFOOD, Inc.</p>
                    <p className='terms-text'>637 Rivanna Hill Rd, Glen Allen</p>
                    <p className='terms-text'>Richmond, VA 23060</p>
                    <p className='terms-text'>Customer Support</p>
                    <p className='terms-text'>Telephone Number: +1 (804)-481-9892</p>
                </section>
            </div>
        </div>
    );
};

export default TermsAndCondition;
